(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

require('bootstrap/js/dist/tooltip');

require('../../../modules/modules');

var _utilities = require('./utilities');

var _objectFitImages = require('object-fit-images');

var _objectFitImages2 = _interopRequireDefault(_objectFitImages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import 'bootstrap/js/dist/alert'
// import 'bootstrap/js/dist/button'
// import 'bootstrap/js/dist/carousel'
// import 'bootstrap/js/dist/modal'
// import 'bootstrap/js/dist/popover'
// import 'bootstrap/js/dist/scrollspy'
jQuery(function ($) {
  $(document).ready(function () {
    outdatedBrowser({
      bgColor: '#f25648',
      color: '#ffffff',
      lowerThan: 'IE11',
      languagePath: '../node_modules/outdated-browser/outdatedbrowser/lang/en.html'
    });
    (0, _utilities.superscript)();
  });
  $(function () {
    (0, _objectFitImages2.default)();
  });

  $('.scroll-link').click(function (e) {
    e.preventDefault();
    $(this).blur();
    var string = $(this).attr('href').split('#')[1];
    $('#' + string).velocity('scroll', { duration: 400, offset: -250 });
    window.location.hash = '#' + string;
  });

  $(window).on('load', function () {
    if (window.location.hash) {
      var hash = window.location.hash;

      if ($(hash).length) {
        $(hash).velocity('scroll', { duration: 400, offset: -250 });
      }
    }
  });
});

},{"../../../modules/modules":5,"./utilities":2,"bootstrap/js/dist/tooltip":3,"object-fit-images":4}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
==========================================================================
utility functions
==========================================================================
*/
function getCookie(name) {
  var value = '; ' + document.cookie;
  var parts = value.split('; ' + name + '=');
  if (parts.length == 2) return parts.pop().split(';').shift();
}

function setCookie(name, value, days) {
  var date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  var expires = '; expires=' + date.toGMTString();
  document.cookie = name + '=' + value + expires + ';path=/';
}

function getParam(p) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.search;

  var match = RegExp('[?&]' + p + '=([^&]*)').exec(url);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

function getParams() {
  var query = window.location.search;

  return query ? (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce(function (params, param) {
    var _param$split = param.split('='),
        _param$split2 = _slicedToArray(_param$split, 2),
        key = _param$split2[0],
        value = _param$split2[1];

    params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
    return params;
  }, {}) : false;
}

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
        args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function superscript() {
  jQuery(function ($) {
    $('p,h1,h2,h3,h4,h5,h6,li,a,span,td,th,i,b,u,em,strong,del,label,small').contents().filter(function () {
      return this.nodeType === 3;
    }).replaceWith(function () {
      return this.nodeValue.replace(/[®™️]/g, '<sup>$&</sup>');
    });
  });
}

function urlDecode(str) {
  return decodeURIComponent((str + '').replace(/\+/g, '%20'));
}

/*
==========================================================================
class utility
==========================================================================
*/

var RezberryClass = function () {
  _createClass(RezberryClass, [{
    key: 'addListeners',


    /*
    ==========================================================================
    listeners
    ==========================================================================
    */
    value: function addListeners() {
      for (var selector in this.listeners) {
        this.addListener(selector, this.listeners[selector]);
      }
    }
  }, {
    key: 'addListener',
    value: function addListener(selector, listener) {
      if (listener instanceof Array) {
        for (var item in listener) {
          if (!listener.hasOwnProperty(item)) continue;
          this.addListener(selector, listener[item]);
        }
      } else {
        this[selector].on(listener.ev, this[listener.func].bind(this));
      }
    }

    /*
    ==========================================================================
    selectors
    ==========================================================================
    */

  }, {
    key: 'addSelectors',
    value: function addSelectors() {
      for (var name in this.selectors) {
        this.addSelector(name, this.selectors[name]);
      }
    }
  }, {
    key: 'addSelector',
    value: function addSelector(name, selector) {
      this['$' + name] = this.$scope.find(selector);
    }

    /*
    ==========================================================================
    init
    ==========================================================================
    */

  }]);

  function RezberryClass(scope) {
    _classCallCheck(this, RezberryClass);

    this.$scope = jQuery(scope);
  }

  return RezberryClass;
}();

/*
==========================================================================
export
==========================================================================
*/


exports.getCookie = getCookie;
exports.setCookie = setCookie;
exports.getParam = getParam;
exports.getParams = getParams;
exports.debounce = debounce;
exports.superscript = superscript;
exports.urlDecode = urlDecode;
exports.RezberryClass = RezberryClass;

},{}],3:[function(require,module,exports){
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0): tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */
var Tooltip = function ($) {
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */
  var NAME = 'tooltip';
  var VERSION = '4.0.0';
  var DATA_KEY = 'bs.tooltip';
  var EVENT_KEY = "." + DATA_KEY;
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var TRANSITION_DURATION = 150;
  var CLASS_PREFIX = 'bs-tooltip';
  var BSCLS_PREFIX_REGEX = new RegExp("(^|\\s)" + CLASS_PREFIX + "\\S+", 'g');
  var DefaultType = {
    animation: 'boolean',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string',
    delay: '(number|object)',
    html: 'boolean',
    selector: '(string|boolean)',
    placement: '(string|function)',
    offset: '(number|string)',
    container: '(string|element|boolean)',
    fallbackPlacement: '(string|array)',
    boundary: '(string|element)'
  };
  var AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: 'right',
    BOTTOM: 'bottom',
    LEFT: 'left'
  };
  var Default = {
    animation: true,
    template: '<div class="tooltip" role="tooltip">' + '<div class="arrow"></div>' + '<div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    selector: false,
    placement: 'top',
    offset: 0,
    container: false,
    fallbackPlacement: 'flip',
    boundary: 'scrollParent'
  };
  var HoverState = {
    SHOW: 'show',
    OUT: 'out'
  };
  var Event = {
    HIDE: "hide" + EVENT_KEY,
    HIDDEN: "hidden" + EVENT_KEY,
    SHOW: "show" + EVENT_KEY,
    SHOWN: "shown" + EVENT_KEY,
    INSERTED: "inserted" + EVENT_KEY,
    CLICK: "click" + EVENT_KEY,
    FOCUSIN: "focusin" + EVENT_KEY,
    FOCUSOUT: "focusout" + EVENT_KEY,
    MOUSEENTER: "mouseenter" + EVENT_KEY,
    MOUSELEAVE: "mouseleave" + EVENT_KEY
  };
  var ClassName = {
    FADE: 'fade',
    SHOW: 'show'
  };
  var Selector = {
    TOOLTIP: '.tooltip',
    TOOLTIP_INNER: '.tooltip-inner',
    ARROW: '.arrow'
  };
  var Trigger = {
    HOVER: 'hover',
    FOCUS: 'focus',
    CLICK: 'click',
    MANUAL: 'manual'
    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };

  var Tooltip =
  /*#__PURE__*/
  function () {
    function Tooltip(element, config) {
      /**
       * Check for Popper dependency
       * Popper - https://popper.js.org
       */
      if (typeof Popper === 'undefined') {
        throw new TypeError('Bootstrap tooltips require Popper.js (https://popper.js.org)');
      } // private


      this._isEnabled = true;
      this._timeout = 0;
      this._hoverState = '';
      this._activeTrigger = {};
      this._popper = null; // Protected

      this.element = element;
      this.config = this._getConfig(config);
      this.tip = null;

      this._setListeners();
    } // Getters


    var _proto = Tooltip.prototype;

    // Public
    _proto.enable = function enable() {
      this._isEnabled = true;
    };

    _proto.disable = function disable() {
      this._isEnabled = false;
    };

    _proto.toggleEnabled = function toggleEnabled() {
      this._isEnabled = !this._isEnabled;
    };

    _proto.toggle = function toggle(event) {
      if (!this._isEnabled) {
        return;
      }

      if (event) {
        var dataKey = this.constructor.DATA_KEY;
        var context = $(event.currentTarget).data(dataKey);

        if (!context) {
          context = new this.constructor(event.currentTarget, this._getDelegateConfig());
          $(event.currentTarget).data(dataKey, context);
        }

        context._activeTrigger.click = !context._activeTrigger.click;

        if (context._isWithActiveTrigger()) {
          context._enter(null, context);
        } else {
          context._leave(null, context);
        }
      } else {
        if ($(this.getTipElement()).hasClass(ClassName.SHOW)) {
          this._leave(null, this);

          return;
        }

        this._enter(null, this);
      }
    };

    _proto.dispose = function dispose() {
      clearTimeout(this._timeout);
      $.removeData(this.element, this.constructor.DATA_KEY);
      $(this.element).off(this.constructor.EVENT_KEY);
      $(this.element).closest('.modal').off('hide.bs.modal');

      if (this.tip) {
        $(this.tip).remove();
      }

      this._isEnabled = null;
      this._timeout = null;
      this._hoverState = null;
      this._activeTrigger = null;

      if (this._popper !== null) {
        this._popper.destroy();
      }

      this._popper = null;
      this.element = null;
      this.config = null;
      this.tip = null;
    };

    _proto.show = function show() {
      var _this = this;

      if ($(this.element).css('display') === 'none') {
        throw new Error('Please use show on visible elements');
      }

      var showEvent = $.Event(this.constructor.Event.SHOW);

      if (this.isWithContent() && this._isEnabled) {
        $(this.element).trigger(showEvent);
        var isInTheDom = $.contains(this.element.ownerDocument.documentElement, this.element);

        if (showEvent.isDefaultPrevented() || !isInTheDom) {
          return;
        }

        var tip = this.getTipElement();
        var tipId = Util.getUID(this.constructor.NAME);
        tip.setAttribute('id', tipId);
        this.element.setAttribute('aria-describedby', tipId);
        this.setContent();

        if (this.config.animation) {
          $(tip).addClass(ClassName.FADE);
        }

        var placement = typeof this.config.placement === 'function' ? this.config.placement.call(this, tip, this.element) : this.config.placement;

        var attachment = this._getAttachment(placement);

        this.addAttachmentClass(attachment);
        var container = this.config.container === false ? document.body : $(this.config.container);
        $(tip).data(this.constructor.DATA_KEY, this);

        if (!$.contains(this.element.ownerDocument.documentElement, this.tip)) {
          $(tip).appendTo(container);
        }

        $(this.element).trigger(this.constructor.Event.INSERTED);
        this._popper = new Popper(this.element, tip, {
          placement: attachment,
          modifiers: {
            offset: {
              offset: this.config.offset
            },
            flip: {
              behavior: this.config.fallbackPlacement
            },
            arrow: {
              element: Selector.ARROW
            },
            preventOverflow: {
              boundariesElement: this.config.boundary
            }
          },
          onCreate: function onCreate(data) {
            if (data.originalPlacement !== data.placement) {
              _this._handlePopperPlacementChange(data);
            }
          },
          onUpdate: function onUpdate(data) {
            _this._handlePopperPlacementChange(data);
          }
        });
        $(tip).addClass(ClassName.SHOW); // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html

        if ('ontouchstart' in document.documentElement) {
          $('body').children().on('mouseover', null, $.noop);
        }

        var complete = function complete() {
          if (_this.config.animation) {
            _this._fixTransition();
          }

          var prevHoverState = _this._hoverState;
          _this._hoverState = null;
          $(_this.element).trigger(_this.constructor.Event.SHOWN);

          if (prevHoverState === HoverState.OUT) {
            _this._leave(null, _this);
          }
        };

        if (Util.supportsTransitionEnd() && $(this.tip).hasClass(ClassName.FADE)) {
          $(this.tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(Tooltip._TRANSITION_DURATION);
        } else {
          complete();
        }
      }
    };

    _proto.hide = function hide(callback) {
      var _this2 = this;

      var tip = this.getTipElement();
      var hideEvent = $.Event(this.constructor.Event.HIDE);

      var complete = function complete() {
        if (_this2._hoverState !== HoverState.SHOW && tip.parentNode) {
          tip.parentNode.removeChild(tip);
        }

        _this2._cleanTipClass();

        _this2.element.removeAttribute('aria-describedby');

        $(_this2.element).trigger(_this2.constructor.Event.HIDDEN);

        if (_this2._popper !== null) {
          _this2._popper.destroy();
        }

        if (callback) {
          callback();
        }
      };

      $(this.element).trigger(hideEvent);

      if (hideEvent.isDefaultPrevented()) {
        return;
      }

      $(tip).removeClass(ClassName.SHOW); // If this is a touch-enabled device we remove the extra
      // empty mouseover listeners we added for iOS support

      if ('ontouchstart' in document.documentElement) {
        $('body').children().off('mouseover', null, $.noop);
      }

      this._activeTrigger[Trigger.CLICK] = false;
      this._activeTrigger[Trigger.FOCUS] = false;
      this._activeTrigger[Trigger.HOVER] = false;

      if (Util.supportsTransitionEnd() && $(this.tip).hasClass(ClassName.FADE)) {
        $(tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
      } else {
        complete();
      }

      this._hoverState = '';
    };

    _proto.update = function update() {
      if (this._popper !== null) {
        this._popper.scheduleUpdate();
      }
    }; // Protected


    _proto.isWithContent = function isWithContent() {
      return Boolean(this.getTitle());
    };

    _proto.addAttachmentClass = function addAttachmentClass(attachment) {
      $(this.getTipElement()).addClass(CLASS_PREFIX + "-" + attachment);
    };

    _proto.getTipElement = function getTipElement() {
      this.tip = this.tip || $(this.config.template)[0];
      return this.tip;
    };

    _proto.setContent = function setContent() {
      var $tip = $(this.getTipElement());
      this.setElementContent($tip.find(Selector.TOOLTIP_INNER), this.getTitle());
      $tip.removeClass(ClassName.FADE + " " + ClassName.SHOW);
    };

    _proto.setElementContent = function setElementContent($element, content) {
      var html = this.config.html;

      if (typeof content === 'object' && (content.nodeType || content.jquery)) {
        // Content is a DOM node or a jQuery
        if (html) {
          if (!$(content).parent().is($element)) {
            $element.empty().append(content);
          }
        } else {
          $element.text($(content).text());
        }
      } else {
        $element[html ? 'html' : 'text'](content);
      }
    };

    _proto.getTitle = function getTitle() {
      var title = this.element.getAttribute('data-original-title');

      if (!title) {
        title = typeof this.config.title === 'function' ? this.config.title.call(this.element) : this.config.title;
      }

      return title;
    }; // Private


    _proto._getAttachment = function _getAttachment(placement) {
      return AttachmentMap[placement.toUpperCase()];
    };

    _proto._setListeners = function _setListeners() {
      var _this3 = this;

      var triggers = this.config.trigger.split(' ');
      triggers.forEach(function (trigger) {
        if (trigger === 'click') {
          $(_this3.element).on(_this3.constructor.Event.CLICK, _this3.config.selector, function (event) {
            return _this3.toggle(event);
          });
        } else if (trigger !== Trigger.MANUAL) {
          var eventIn = trigger === Trigger.HOVER ? _this3.constructor.Event.MOUSEENTER : _this3.constructor.Event.FOCUSIN;
          var eventOut = trigger === Trigger.HOVER ? _this3.constructor.Event.MOUSELEAVE : _this3.constructor.Event.FOCUSOUT;
          $(_this3.element).on(eventIn, _this3.config.selector, function (event) {
            return _this3._enter(event);
          }).on(eventOut, _this3.config.selector, function (event) {
            return _this3._leave(event);
          });
        }

        $(_this3.element).closest('.modal').on('hide.bs.modal', function () {
          return _this3.hide();
        });
      });

      if (this.config.selector) {
        this.config = _extends({}, this.config, {
          trigger: 'manual',
          selector: ''
        });
      } else {
        this._fixTitle();
      }
    };

    _proto._fixTitle = function _fixTitle() {
      var titleType = typeof this.element.getAttribute('data-original-title');

      if (this.element.getAttribute('title') || titleType !== 'string') {
        this.element.setAttribute('data-original-title', this.element.getAttribute('title') || '');
        this.element.setAttribute('title', '');
      }
    };

    _proto._enter = function _enter(event, context) {
      var dataKey = this.constructor.DATA_KEY;
      context = context || $(event.currentTarget).data(dataKey);

      if (!context) {
        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
        $(event.currentTarget).data(dataKey, context);
      }

      if (event) {
        context._activeTrigger[event.type === 'focusin' ? Trigger.FOCUS : Trigger.HOVER] = true;
      }

      if ($(context.getTipElement()).hasClass(ClassName.SHOW) || context._hoverState === HoverState.SHOW) {
        context._hoverState = HoverState.SHOW;
        return;
      }

      clearTimeout(context._timeout);
      context._hoverState = HoverState.SHOW;

      if (!context.config.delay || !context.config.delay.show) {
        context.show();
        return;
      }

      context._timeout = setTimeout(function () {
        if (context._hoverState === HoverState.SHOW) {
          context.show();
        }
      }, context.config.delay.show);
    };

    _proto._leave = function _leave(event, context) {
      var dataKey = this.constructor.DATA_KEY;
      context = context || $(event.currentTarget).data(dataKey);

      if (!context) {
        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
        $(event.currentTarget).data(dataKey, context);
      }

      if (event) {
        context._activeTrigger[event.type === 'focusout' ? Trigger.FOCUS : Trigger.HOVER] = false;
      }

      if (context._isWithActiveTrigger()) {
        return;
      }

      clearTimeout(context._timeout);
      context._hoverState = HoverState.OUT;

      if (!context.config.delay || !context.config.delay.hide) {
        context.hide();
        return;
      }

      context._timeout = setTimeout(function () {
        if (context._hoverState === HoverState.OUT) {
          context.hide();
        }
      }, context.config.delay.hide);
    };

    _proto._isWithActiveTrigger = function _isWithActiveTrigger() {
      for (var trigger in this._activeTrigger) {
        if (this._activeTrigger[trigger]) {
          return true;
        }
      }

      return false;
    };

    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, this.constructor.Default, $(this.element).data(), config);

      if (typeof config.delay === 'number') {
        config.delay = {
          show: config.delay,
          hide: config.delay
        };
      }

      if (typeof config.title === 'number') {
        config.title = config.title.toString();
      }

      if (typeof config.content === 'number') {
        config.content = config.content.toString();
      }

      Util.typeCheckConfig(NAME, config, this.constructor.DefaultType);
      return config;
    };

    _proto._getDelegateConfig = function _getDelegateConfig() {
      var config = {};

      if (this.config) {
        for (var key in this.config) {
          if (this.constructor.Default[key] !== this.config[key]) {
            config[key] = this.config[key];
          }
        }
      }

      return config;
    };

    _proto._cleanTipClass = function _cleanTipClass() {
      var $tip = $(this.getTipElement());
      var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX);

      if (tabClass !== null && tabClass.length > 0) {
        $tip.removeClass(tabClass.join(''));
      }
    };

    _proto._handlePopperPlacementChange = function _handlePopperPlacementChange(data) {
      this._cleanTipClass();

      this.addAttachmentClass(this._getAttachment(data.placement));
    };

    _proto._fixTransition = function _fixTransition() {
      var tip = this.getTipElement();
      var initConfigAnimation = this.config.animation;

      if (tip.getAttribute('x-placement') !== null) {
        return;
      }

      $(tip).removeClass(ClassName.FADE);
      this.config.animation = false;
      this.hide();
      this.show();
      this.config.animation = initConfigAnimation;
    }; // Static


    Tooltip._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        var _config = typeof config === 'object' && config;

        if (!data && /dispose|hide/.test(config)) {
          return;
        }

        if (!data) {
          data = new Tooltip(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    _createClass(Tooltip, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default;
      }
    }, {
      key: "NAME",
      get: function get() {
        return NAME;
      }
    }, {
      key: "DATA_KEY",
      get: function get() {
        return DATA_KEY;
      }
    }, {
      key: "Event",
      get: function get() {
        return Event;
      }
    }, {
      key: "EVENT_KEY",
      get: function get() {
        return EVENT_KEY;
      }
    }, {
      key: "DefaultType",
      get: function get() {
        return DefaultType;
      }
    }]);

    return Tooltip;
  }();
  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */


  $.fn[NAME] = Tooltip._jQueryInterface;
  $.fn[NAME].Constructor = Tooltip;

  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Tooltip._jQueryInterface;
  };

  return Tooltip;
}($, Popper);

},{}],4:[function(require,module,exports){
/*! npm.im/object-fit-images 3.2.4 */
'use strict';

var OFI = 'bfred-it:object-fit-images';
var propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g;
var testImg = typeof Image === 'undefined' ? {style: {'object-position': 1}} : new Image();
var supportsObjectFit = 'object-fit' in testImg.style;
var supportsObjectPosition = 'object-position' in testImg.style;
var supportsOFI = 'background-size' in testImg.style;
var supportsCurrentSrc = typeof testImg.currentSrc === 'string';
var nativeGetAttribute = testImg.getAttribute;
var nativeSetAttribute = testImg.setAttribute;
var autoModeEnabled = false;

function createPlaceholder(w, h) {
	return ("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E");
}

function polyfillCurrentSrc(el) {
	if (el.srcset && !supportsCurrentSrc && window.picturefill) {
		var pf = window.picturefill._;
		// parse srcset with picturefill where currentSrc isn't available
		if (!el[pf.ns] || !el[pf.ns].evaled) {
			// force synchronous srcset parsing
			pf.fillImg(el, {reselect: true});
		}

		if (!el[pf.ns].curSrc) {
			// force picturefill to parse srcset
			el[pf.ns].supported = false;
			pf.fillImg(el, {reselect: true});
		}

		// retrieve parsed currentSrc, if any
		el.currentSrc = el[pf.ns].curSrc || el.src;
	}
}

function getStyle(el) {
	var style = getComputedStyle(el).fontFamily;
	var parsed;
	var props = {};
	while ((parsed = propRegex.exec(style)) !== null) {
		props[parsed[1]] = parsed[2];
	}
	return props;
}

function setPlaceholder(img, width, height) {
	// Default: fill width, no height
	var placeholder = createPlaceholder(width || 1, height || 0);

	// Only set placeholder if it's different
	if (nativeGetAttribute.call(img, 'src') !== placeholder) {
		nativeSetAttribute.call(img, 'src', placeholder);
	}
}

function onImageReady(img, callback) {
	// naturalWidth is only available when the image headers are loaded,
	// this loop will poll it every 100ms.
	if (img.naturalWidth) {
		callback(img);
	} else {
		setTimeout(onImageReady, 100, img, callback);
	}
}

function fixOne(el) {
	var style = getStyle(el);
	var ofi = el[OFI];
	style['object-fit'] = style['object-fit'] || 'fill'; // default value

	// Avoid running where unnecessary, unless OFI had already done its deed
	if (!ofi.img) {
		// fill is the default behavior so no action is necessary
		if (style['object-fit'] === 'fill') {
			return;
		}

		// Where object-fit is supported and object-position isn't (Safari < 10)
		if (
			!ofi.skipTest && // unless user wants to apply regardless of browser support
			supportsObjectFit && // if browser already supports object-fit
			!style['object-position'] // unless object-position is used
		) {
			return;
		}
	}

	// keep a clone in memory while resetting the original to a blank
	if (!ofi.img) {
		ofi.img = new Image(el.width, el.height);
		ofi.img.srcset = nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
		ofi.img.src = nativeGetAttribute.call(el, "data-ofi-src") || el.src;

		// preserve for any future cloneNode calls
		// https://github.com/bfred-it/object-fit-images/issues/53
		nativeSetAttribute.call(el, "data-ofi-src", el.src);
		if (el.srcset) {
			nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
		}

		setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);

		// remove srcset because it overrides src
		if (el.srcset) {
			el.srcset = '';
		}
		try {
			keepSrcUsable(el);
		} catch (err) {
			if (window.console) {
				console.warn('https://bit.ly/ofi-old-browser');
			}
		}
	}

	polyfillCurrentSrc(ofi.img);

	el.style.backgroundImage = "url(\"" + ((ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"')) + "\")";
	el.style.backgroundPosition = style['object-position'] || 'center';
	el.style.backgroundRepeat = 'no-repeat';
	el.style.backgroundOrigin = 'content-box';

	if (/scale-down/.test(style['object-fit'])) {
		onImageReady(ofi.img, function () {
			if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) {
				el.style.backgroundSize = 'contain';
			} else {
				el.style.backgroundSize = 'auto';
			}
		});
	} else {
		el.style.backgroundSize = style['object-fit'].replace('none', 'auto').replace('fill', '100% 100%');
	}

	onImageReady(ofi.img, function (img) {
		setPlaceholder(el, img.naturalWidth, img.naturalHeight);
	});
}

function keepSrcUsable(el) {
	var descriptors = {
		get: function get(prop) {
			return el[OFI].img[prop ? prop : 'src'];
		},
		set: function set(value, prop) {
			el[OFI].img[prop ? prop : 'src'] = value;
			nativeSetAttribute.call(el, ("data-ofi-" + prop), value); // preserve for any future cloneNode
			fixOne(el);
			return value;
		}
	};
	Object.defineProperty(el, 'src', descriptors);
	Object.defineProperty(el, 'currentSrc', {
		get: function () { return descriptors.get('currentSrc'); }
	});
	Object.defineProperty(el, 'srcset', {
		get: function () { return descriptors.get('srcset'); },
		set: function (ss) { return descriptors.set(ss, 'srcset'); }
	});
}

function hijackAttributes() {
	function getOfiImageMaybe(el, name) {
		return el[OFI] && el[OFI].img && (name === 'src' || name === 'srcset') ? el[OFI].img : el;
	}
	if (!supportsObjectPosition) {
		HTMLImageElement.prototype.getAttribute = function (name) {
			return nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
		};

		HTMLImageElement.prototype.setAttribute = function (name, value) {
			return nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
		};
	}
}

function fix(imgs, opts) {
	var startAutoMode = !autoModeEnabled && !imgs;
	opts = opts || {};
	imgs = imgs || 'img';

	if ((supportsObjectPosition && !opts.skipTest) || !supportsOFI) {
		return false;
	}

	// use imgs as a selector or just select all images
	if (imgs === 'img') {
		imgs = document.getElementsByTagName('img');
	} else if (typeof imgs === 'string') {
		imgs = document.querySelectorAll(imgs);
	} else if (!('length' in imgs)) {
		imgs = [imgs];
	}

	// apply fix to all
	for (var i = 0; i < imgs.length; i++) {
		imgs[i][OFI] = imgs[i][OFI] || {
			skipTest: opts.skipTest
		};
		fixOne(imgs[i]);
	}

	if (startAutoMode) {
		document.body.addEventListener('load', function (e) {
			if (e.target.tagName === 'IMG') {
				fix(e.target, {
					skipTest: opts.skipTest
				});
			}
		}, true);
		autoModeEnabled = true;
		imgs = 'img'; // reset to a generic selector for watchMQ
	}

	// if requested, watch media queries for object-fit change
	if (opts.watchMQ) {
		window.addEventListener('resize', fix.bind(null, imgs, {
			skipTest: opts.skipTest
		}));
	}
}

fix.supportsObjectFit = supportsObjectFit;
fix.supportsObjectPosition = supportsObjectPosition;

hijackAttributes();

module.exports = fix;

},{}],5:[function(require,module,exports){
'use strict';

require('./molecules/filter/filter');

require('./molecules/filters/filters');

require('./molecules/form/form');

require('./molecules/loading/loading');

require('./molecules/popup-gallery/popup-gallery');

require('./molecules/popup-iframe/popup-iframe');

require('./molecules/overlap/overlap');

require('./molecules/slick/slick');

require('./molecules/search-form/search-form');

require('./molecules/video/video');

require('./molecules/view-more/view-more');

require('./molecules/popup-modal/popup-modal');

require('./organisms/alert/alert');

require('./organisms/footer-back-to-top/footer-back-to-top');

require('./organisms/footer-cookies/footer-cookies');

require('./organisms/header/header');

require('./organisms/header-eyebrow/header-eyebrow');

require('./organisms/header-nav/header-nav');

require('./organisms/subnav/subnav');

require('./organisms/01-hero/01-hero');

require('./organisms/01b-home-hero/01b-home-hero');

require('./organisms/05a-brackets/05a-brackets');

require('./organisms/05b-brackets/05b-brackets');

require('./organisms/06c-billboard/06c-billboard');

require('./organisms/07a-two-col-text-media/07a-two-col-text-media');

require('./organisms/07c-two-col-text-media/07c-two-col-text-media');

require('./organisms/07d-two-col-text-media/07d-two-col-text-media');

require('./organisms/08a-two-col-text-list/08a-two-col-text-list');

require('./organisms/08b-two-col-text-list/08b-two-col-text-list');

require('./organisms/09-two-col-text-stats/09-two-col-text-stats');

require('./organisms/10b-two-col-wysiwyg/10b-two-col-wysiwyg');

require('./organisms/13b-logos/13b-logos');

require('./organisms/14a-testimonials/14a-testimonials');

require('./organisms/14b-testimonials/14b-testimonials');

require('./organisms/16c-related-reading/16c-related-reading');

require('./organisms/17-featured-insights/17-featured-insights');

require('./organisms/20-full-width-image-content/20-full-width-image-content');

require('./organisms/24-accordions/24-accordions');

require('./organisms/27-solutions-filter/27-solutions-filter');

require('./organisms/28-quiz/28-quiz-fleet');

require('./organisms/28-quiz/28-quiz-workforce');

require('./organisms/28-quiz/28-quiz-childhood');

require('./organisms/28-quiz/28-quiz-k12');

require('./organisms/29-drawer-cta/29-drawer-cta');

/* Check same file in parent theme for examples. */

$(window).on('orientationchange resize scroll', function () {
  cardAnimate();
  //photoBgSize() <-- console log says undefined
  entrances();
});
// import './molecules/grid-features/grid-features'


$(window).on('load', function () {
  cardAnimate();
  //photoBgSize() <-- console log says undefined

  setTimeout(function () {
    $('.pre-render').removeClass('pre-render');
    $('.m-page-intro-img').addClass('in');
    $('.delay-animation').removeClass('delay-animation').addClass('in');
  }, 200);
});

setTimeout(function () {
  $('.pre-render').removeClass('pre-render');
  $('.m-page-intro-header h1, .m-page-intro-content, .m-page-intro-img, .hero-fade, .hero-fade-delay, .hero-fade-slideup, .hero-title-gradient').addClass('in');
  $('.delay-animation').removeClass('delay-animation').addClass('in');
}, 200);

$(function () {

  setTimeout(function () {
    $('.pre-render').removeClass('pre-render');
    $('.m-page-intro-header h1, .m-page-intro-content, .hero-fade, .hero-fade-delay, .hero-fade-slideup, .hero-title-gradient').addClass('in');
  }, 200);

  entrances();
});

function entrances() {

  var scrollTop = $(window).scrollTop();
  var windowBottom = scrollTop + $(window).height();
  windowBottom = windowBottom - 100;

  $('.fade:not(.delay-animation), .fade-slideup:not(.delay-animation), .stagger-animation:not(.delay-animation), .slideleft:not(.delay-animation), .slideup:not(.delay-animation), .slideright:not(.delay-animation), .watermark-animate:not(.delay-animation), .draw-arrow:not(.delay-animation)').each(function () {
    var objectTop = $(this).offset().top;
    if (objectTop < windowBottom) {
      $(this).addClass('in');
      if ($(this).hasClass('slideleft')) {
        $(this).parents('.slideleft-wrapper').addClass('in');
      } else if ($(this).hasClass('stagger-animation')) {
        $(this).find('.stagger-item:not(.card, .card-stagger-item, .content-grid-item, .bracket-stagger-item)').addClass('in');
      }
    } else {
      if ($(this).hasClass('in')) {
        $(this).removeClass('in');
        if ($(this).hasClass('slideleft')) {
          $(this).parents('.slideleft-wrapper').removeClass('in');
        } else if ($(this).hasClass('stagger-animation')) {
          $(this).find('.stagger-item:not(.card, .card-stagger-item, .content-grid-item, .bracket-stagger-item)').removeClass('in');
        }
      }
    }
  });

  $('.gradient-border').each(function () {
    var borderTop = $(this).offset().top;
    if ($(this).hasClass('hero-border') && $(this).parents('.hero').hasClass('hero-feature')) {
      windowBottom = windowBottom + 100;
    } else {
      windowBottom = windowBottom;
    }
    // windowBottom = windowBottom + 100
    if (borderTop < windowBottom) {
      $(this).addClass('in');
    } else {
      if ($(this).hasClass('in')) {
        $(this).removeClass('in');
      }
    }
  });

  if ($(this).hasClass('card')) {
    var elBottom = $(this).offset().top + $(this).innerHeight();
    if (scrollTop >= elBottom - window.innerHeight) {
      $(this).addClass('in');
    }
  }
}

function triggerCardAnimateTop(el, triggerPoint, top) {
  if (top >= triggerPoint - window.innerHeight) {
    $(el).addClass('in');
  } else {
    $(el).removeClass('in');
  }
}
function triggerCardAnimateBottom(el, triggerPoint, bottom) {
  if (triggerPoint < bottom) {
    $(el).addClass('in');
  } else {
    $(el).removeClass('in');
  }
}

function cardAnimate() {

  var scrollTop = $(window).scrollTop();
  var windowBottom = scrollTop + $(window).height();
  var breakpoint = 768;

  $('.card.stagger-item, .card-stagger-item.stagger-item, .content-grid-item.stagger-item, .bracket-stagger-item.stagger-item').each(function () {
    if ($(this).parents('.stagger-animation').hasClass('service-feature-list-cards')) {
      breakpoint = 1260;
    }
    var trigger;
    if ($(window).innerWidth() < breakpoint) {
      if ($(this).prev().hasClass('in')) {
        trigger = $(this).prev().offset().top + $(this).prev().innerHeight();
        trigger + 20;
        triggerCardAnimateTop($(this), trigger, scrollTop);
      } else {
        trigger = $(this).offset().top;
        triggerCardAnimateBottom($(this), trigger, windowBottom);
      }
    } else {
      if (($(this).hasClass('three-col') || $(this).hasClass('col-lg-4')) && $(window).width() >= 992) {
        trigger = $(this).offset().top;
        triggerCardAnimateBottom($(this), trigger, windowBottom);
      } else {

        if ($(this).is(':nth-of-type(odd):not(.card-more-link)')) {
          $(this).addClass('odd-first');
          trigger = $(this).offset().top;
          triggerCardAnimateBottom($(this), trigger, windowBottom);
        } else {
          $(this).addClass('even');
          trigger = $(this).offset().top;
          triggerCardAnimateBottom($(this), trigger, windowBottom);
        }
      }
    }
  });
}

/*------------------------------------
 Brackets with Image img size
--------------------------------------*/
function bracketsImageSize() {
  if ($(window).innerWidth() >= 567 && $(window).innerWidth() < 768) {
    $('.m-brackets-image-bracket-img.img-square').removeClass('img-square').addClass('img-rectangle');
  }
}

},{"./molecules/filter/filter":6,"./molecules/filters/filters":7,"./molecules/form/form":8,"./molecules/loading/loading":9,"./molecules/overlap/overlap":10,"./molecules/popup-gallery/popup-gallery":11,"./molecules/popup-iframe/popup-iframe":12,"./molecules/popup-modal/popup-modal":13,"./molecules/search-form/search-form":14,"./molecules/slick/slick":15,"./molecules/video/video":16,"./molecules/view-more/view-more":17,"./organisms/01-hero/01-hero":18,"./organisms/01b-home-hero/01b-home-hero":19,"./organisms/05a-brackets/05a-brackets":20,"./organisms/05b-brackets/05b-brackets":21,"./organisms/06c-billboard/06c-billboard":22,"./organisms/07a-two-col-text-media/07a-two-col-text-media":23,"./organisms/07c-two-col-text-media/07c-two-col-text-media":24,"./organisms/07d-two-col-text-media/07d-two-col-text-media":25,"./organisms/08a-two-col-text-list/08a-two-col-text-list":26,"./organisms/08b-two-col-text-list/08b-two-col-text-list":27,"./organisms/09-two-col-text-stats/09-two-col-text-stats":28,"./organisms/10b-two-col-wysiwyg/10b-two-col-wysiwyg":29,"./organisms/13b-logos/13b-logos":30,"./organisms/14a-testimonials/14a-testimonials":31,"./organisms/14b-testimonials/14b-testimonials":32,"./organisms/16c-related-reading/16c-related-reading":33,"./organisms/17-featured-insights/17-featured-insights":34,"./organisms/20-full-width-image-content/20-full-width-image-content":35,"./organisms/24-accordions/24-accordions":36,"./organisms/27-solutions-filter/27-solutions-filter":37,"./organisms/28-quiz/28-quiz-childhood":38,"./organisms/28-quiz/28-quiz-fleet":39,"./organisms/28-quiz/28-quiz-k12":40,"./organisms/28-quiz/28-quiz-workforce":41,"./organisms/29-drawer-cta/29-drawer-cta":42,"./organisms/alert/alert":43,"./organisms/footer-back-to-top/footer-back-to-top":44,"./organisms/footer-cookies/footer-cookies":45,"./organisms/header-eyebrow/header-eyebrow":46,"./organisms/header-nav/header-nav":47,"./organisms/header/header":48,"./organisms/subnav/subnav":49}],6:[function(require,module,exports){
'use strict';

var _utilities = require('../../../assets/src/js/utilities');

jQuery(function ($) {
  $(document).ready(function () {
    $(document).on('click', '.js-filter-value', function (e) {
      e.preventDefault();

      var $this = $(this),
          $filterWrapper = $this.parents('.js-filter-values').first(),
          endpoint = $filterWrapper.data('endpoint'),
          exclusive = $filterWrapper.data('exclusive'),
          $wrapper = $this.parents('[rez-app]');

      $filterWrapper.find('.js-filter-value').removeClass('is-active');

      if (exclusive) {
        var $otherWrappers = $wrapper.find('.js-filter-values').not($filterWrapper),
            $otherValues = $otherWrappers.find('.js-filter-value');
        $otherValues.removeClass('is-active');
        $otherValues.filter('[data-value="any"]').addClass('is-active');
      }

      $this.addClass('is-active');

      var $active = $wrapper.find('.js-filter-value.is-active').filter(':visible'),
          fields = [],
          operators = [],
          values = [],
          text = '';

      $active.each(function (index, item) {
        var $item = $(item),
            trimmed = $.trim($item.text());

        fields.push($item.data('field'));
        operators.push($item.data('operator') ? $item.data('operator') : 'equal');
        values.push($item.data('value'));

        $wrapper.find('.filter-indicator-' + (index + 1)).text(trimmed);

        if ($item.data('value') != 'any') {
          var newText = $item.data('label') + trimmed;
          text += !text.length ? newText : ', ' + newText;
        }
      });

      if (!text.length) text = 'Everything';
      $('.filters-desktop .filters-indicator').text(text);

      $('.filters-mobile .filters-group').collapse('hide');

      $('.loading').show();
      $.ajax({
        type: 'GET',
        url: endpoint,
        data: {
          fields: fields,
          operators: operators,
          values: values
        },
        success: function success(res) {
          $wrapper.find('.js-filters-stage').first().html(res);
          (0, _utilities.superscript)();
          $('.loading').hide();
        }
      });
    });

    var $active = $('.js-filter-value.is-active').filter(':visible');
    if ($active.length) {
      $active.each(function (index, item) {
        var $item = $(item);
        if ($item.data('value') != 'any') $item.trigger('click');
      });
    }
  });
});

},{"../../../assets/src/js/utilities":2}],7:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    $('.filters-mobile .filters-group').on('show.bs.collapse', function () {
      $(this).parents('.filters-mobile').addClass('is-active');
    });
    $('.filters-mobile .filters-group').on('hidden.bs.collapse', function () {
      $(this).parents('.filters-mobile').removeClass('is-active');
    });
  });
});

},{}],8:[function(require,module,exports){
'use strict';

/*------------------------------------
  Form Functions
--------------------------------------*/
var inputs = '.hbspt-form input:not([type="radio"]):not([type="checkbox"]):not([type="submit"]):not([type="button"]):not([type="image"]):not([type="file"]):visible, .hbspt-form textarea:visible, .hbspt-form select';

$(window).on('load', function () {
  $('.hbspt-form .hs-form-field').each(function () {
    if ($(this).find('.hs-form-required').length > 0) {
      $(this).addClass('required');
    }
  });
  setTimeout(function () {
    checkPrepopulatedFields();
  }, 200);

  $('.popup-modal').on('click', function () {
    setTimeout(function () {
      checkPrepopulatedFields();
    }, 200);
  });

  // $('.hbspt-form .hs-form textarea').eachgulp(function() {
  //   var offset = $(this).offsetHeight - $(this).clientHeight
  //   $(this).addClass('hello')
  //   console.log(offset)

  //   var resizeArea = function(el) {
  //     $(el).css('height', '50px').css('height', el.scrollHeight + offset)
  //     $(el).parents('.hs-fieldtype-textarea').css('height', el.scrollHeight + offset)
  //     $(el).parents('fieldset').css('height', el.scrollHeight + offset)
  //   }

  //   $(this).on('keyup input', function() {
  //     console.log(offset)
  //     resizeArea($(this))
  //   })
  // })
});

function checkPrepopulatedFields() {
  $(inputs).each(function () {
    if ($(this).val() !== '') {
      $(this).parents('.hs-form-field').find('label:first').addClass('in-focus');

      if ($(this).parents('.hs-form-field').find('.hs-error-msgs:visible')) {
        $(this).parents('.hs-form-field').addClass('invalid');
        $(this).parents('.form-columns-2').addClass('invalid-extra-space');
      }
    }
  });
}

$('.hbspt-form select').on('change', function () {
  if ($(this).find('option:selected').val() != '') {
    $(this).removeClass('holding');
  } else {
    $(this).parents('.hs-form-field').find('label:first').removeClass('in-focus');
  }
});

$(document).on('focus', inputs, function () {
  $(this).parents('.hs-form-field').find('.input').addClass('in-focus');
  $(this).parents('.hs-form-field').find('label:first').addClass('in-focus azure');
});

$(document).on('blur', inputs, function () {
  $(this).parents('.hs-form-field').find('.input').removeClass('in-focus');
  $(this).parents('.hs-form-field').find('label:first').removeClass('in-focus azure');

  if ($(this).val().length > 0) {
    $(this).parents('.hs-form-field').find('label:first').addClass('in-focus');

    if ($(this).hasClass('invalid') || $(this).parents('.hs-form-field').find('.hs-error-msgs:visible')) {
      $(this).parents('.hs-form-field').find('label:first').addClass('invalid');
      $(this).parents('.hs-form-field').addClass('invalid');
    } else {
      $(this).parents('.hs-form-field').find('label:first').removeClass('invalid');
      $(this).parents('.hs-form-field').removeClass('invalid');
    }
  } else {
    $(this).parents('.hs-form-field').find('label:first').removeClass('in-focus');
    if ($(this).parents('.hs-form-field').hasClass('required')) {
      $(this).parents('.hs-form-field').addClass('invalid');
      $(this).parents('.hs-form-field').find('label:first').addClass('invalid');
    }
  }
});

$(window).on('load', function () {
  setTimeout(function () {
    $('textarea').each(function () {
      var offset = this.offsetHeight - this.clientHeight;

      var resizeArea = function resizeArea(el) {
        var newHeight = el.scrollHeight + offset + 20;
        $(el).css('height', '50px').css('height', el.scrollHeight + offset);
        $(el).parents('.hs-fieldtype-textarea').css('height', el.scrollHeight + offset + 22);
      };

      $(this).on('keyup input', function () {
        resizeArea(this);
      });
    });
  }, 500);
});

},{}],9:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    $('.loading:not(:first)').remove();
  });
});

},{}],10:[function(require,module,exports){
'use strict';

jQuery(function ($) {

  $(document).ready(function () {
    // invadedPadding()
  });

  $(window).on('resize, orientationChange', function () {
    // invadedPadding()
  });

  $('.rez-overlap').each(function () {
    var $section;

    if ($(this).is('section')) {
      $section = $(this);
    } else {
      $section = $(this).parents('section');
    }

    var $prevSection = $section.prev('section').not('.m-subnav');

    $prevSection.addClass('rez-space-invaded');

    $prevSection.each(function () {
      var $pbSection = $(this).filter(function () {
        return this.className.match(/\bpb/);
      }),
          pb;

      $pbSection.filter(function () {
        var classes = $(this).attr('class').split(" ");
        for (var i = 0; i < classes.length; i++) {
          if (classes[i].match('^pb')) {
            pb = classes[i];
          }
        }
      });

      $(this).removeClass(pb);
    });
  });

  function invadedPadding() {
    $('.rez-space-invaded').each(function () {
      var ih = $(this).height(),
          oh = $(this).outerHeight(),
          padding;

      console.log('outer:' + oh + '     inner:' + ih);

      if (ih == oh) {
        $(this).css('height', 'auto').css('height', oh + 100);
      } else {
        padding = (oh - ih) / 2;
        // console.log(pb)
        $(this).css('padding-bottom', padding + 100);
      }
    });
  }
});

},{}],11:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.popupGallery = undefined;

var _utilities = require('../../../assets/src/js/utilities');

$(document).ready(function () {
  return popupGallery();
});

function popupGallery() {
  $('.popup-gallery').each(function () {
    $(this).magnificPopup({
      delegate: '.popup-gallery-link:not(.slick-cloned)',
      type: 'image',
      closeBtnInside: false,
      fixedBgPos: true,
      fixedContentPos: true,
      mainClass: 'mfp-img-mobile',
      tLoading: 'Loading image #%curr%...',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0, 1],
        arrowMarkup: '<img alt="%title%" class="m-popup-gallery-arrow mfp-arrow mfp-arrow-%dir%" src="/wp-content/themes/rezberrybud/assets/dist/images/icon-arrow-%dir%-dark.svg">',
        tCounter: '<span class="mfp-counter">%curr% of %total%</span>' // markup of counter
      },
      iframe: {
        tError: '<a href="%url%">The video #%curr%</a> could not be loaded.',
        titleSrc: function titleSrc(item) {
          return item.el.attr('title');
        },
        patterns: {
          youtube: {
            index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

            // id: 'v=', // String that splits URL in a two parts, second part should be %id%
            // Or null - full URL will be returned
            // Or a function that should return %id%, for example:
            // id: function(url) { return 'parsed id'; }
            id: function id(url) {
              return (0, _utilities.getParam)('v', url);
            },

            src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
          },
          vimeo: {
            index: 'vimeo.com/',
            id: '/',
            src: '//player.vimeo.com/video/%id%?autoplay=1'
          },
          wistia: {
            index: 'wistia.com/',
            id: '/medias/',
            src: '//fast.wistia.net/embed/iframe/%id%?videoFoam=true&autoplay=true'
          },
          gmaps: {
            index: '//maps.google.',
            src: '%id%&output=embed'
          }
        },
        markup: '<div class="mfp-iframe-scaler">' + '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' + '</div>' + '<div class="mfp-bottom-bar">' + '<div class="mfp-title"></div>' + '<h5 class="mfp-counter"></h5>' + '</div>'
      },
      image: {
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
        titleSrc: function titleSrc(item) {
          return item.el.attr('title');
        }
      }
    });
  });
}

exports.popupGallery = popupGallery;

},{"../../../assets/src/js/utilities":2}],12:[function(require,module,exports){
'use strict';

var _utilities = require('../../../assets/src/js/utilities');

jQuery(function ($) {
  $('.popup-iframe-link').magnificPopup({
    type: 'iframe',
    fixedBgPos: true,
    fixedContentPos: true,
    midClick: true,
    iframe: {
      patterns: {
        youtube: {
          index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

          // id: 'v=', // String that splits URL in a two parts, second part should be %id%
          // Or null - full URL will be returned
          // Or a function that should return %id%, for example:
          // id: function(url) { return 'parsed id'; }
          id: function id(url) {
            return (0, _utilities.getParam)('v', url);
          },

          src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
        },
        vimeo: {
          index: 'vimeo.com/',
          id: '/',
          src: '//player.vimeo.com/video/%id%?autoplay=1'
        },
        wistia: {
          index: 'wistia.com/',
          id: '/medias/',
          src: '//fast.wistia.net/embed/iframe/%id%?videoFoam=true&autoplay=true'
        },
        gmaps: {
          index: '//maps.google.',
          src: '%id%&output=embed'
        }
      }
    }
  });
});

},{"../../../assets/src/js/utilities":2}],13:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $('.popup-modal').magnificPopup({
    type: 'inline',
    preloader: false
  });
});

},{}],14:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    $('.m-search-form').submit(function (e) {
      if ($(this).find('[type="search"]').val() == '') {
        e.preventDefault();
      }
    });
  });
});

},{}],15:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
$(document).ready(function () {
  slickThis();
});
$(window).on('resize orientationchange', function () {
  slickThis();
});

function slickThis() {
  $('.slick-this:not(.slick-initialized)').each(function () {
    var adaptiveHeight = $(this).data('height'),
        arrows = $(this).data('arrows'),
        autoplay = $(this).data('autoplay'),
        dots = $(this).data('dots'),
        fade = $(this).data('fade'),
        slidesToScroll = $(this).data('scroll'),
        slidesToShow = $(this).data('show'),
        centerMode = $(this).data('centermode'),
        centerPadding = $(this).data('centerpadding');
    //$arrows = $(this).siblings('.m-slider-arrows')

    $(this).slick({
      adaptiveHeight: adaptiveHeight,
      arrows: arrows,
      autoplay: autoplay,
      dots: dots,
      fade: fade,
      infinite: false,
      mobileFirst: true,
      //nextArrow: $arrows.find('.m-slider-arrows-arrow-right'),
      //prevArrow: $arrows.find('.m-slider-arrows-arrow-left'),
      rows: 0,
      slidesToScroll: slidesToScroll,
      slidesToShow: slidesToShow,
      centerMode: centerMode,
      centerPadding: centerPadding
    });
  });
}

exports.slickThis = slickThis;

},{}],16:[function(require,module,exports){
'use strict';

// taken from https://codepen.io/team/rcrooks1969/pen/opXWww

jQuery(function () {
  if (typeof videojs == 'undefined') return;

  // Create array for player IDs
  var players = [];

  // +++  Determine the available player IDs +++//
  for (var x = 0; x < Object.keys(videojs.players).length; x++) {
    // Assign the player name to setPlayer
    var setPlayer = Object.keys(videojs.players)[x];
    // Define the ready event for the player
    videojs.getPlayer(setPlayer).ready(function () {
      // Assign this player to a variable
      var myPlayer = this;
      // Assign and event listener for play event
      myPlayer.on('play', onPlay);
      // Push the player to the players array
      players.push(myPlayer);
    });
  }

  // +++ Handle all players' play event +++//
  function onPlay(e) {
    // Determine which player the event is coming from
    var id = e.target.id;
    // Loop through the array of players
    for (var i = 0; i < players.length; i++) {
      // Get the player(s) that did not trigger the play event
      if (players[i].id() != id) {
        // Pause the other player(s)
        videojs.getPlayer(players[i].id()).pause();
      }
    }
  }
});

},{}],17:[function(require,module,exports){
'use strict';

jQuery(function ($) {

  var ww = window.innerWidth;

  $(document).ready(function () {
    moduleShowToggle();
  });
  $(window).on('resize orientationchange', function () {
    moduleShowToggle();
  });

  function moduleShowToggle() {
    if (ww == window.innerWidth) return;
    $('.m-view-toggle').each(function () {
      var $this = $(this),
          $section = $this.parents('section'),
          cutoff = $this.data('cutoff'),
          numToShow = $this.data('num-to-show'),
          $more = $this.find('.view-more'),
          $less = $this.find('.view-less'),
          $toggleContainer = $section.find('.toggle-this-container');

      $section.find('.toggle-this:lt(' + cutoff + ')').show();
      var items = $section.find('.toggle-this').length,
          shown = cutoff;

      $more.click(function () {
        $(this).siblings('.view-less').show();
        var remaining = items - shown;
        // console.log($toggleContainer)
        if (remaining < numToShow) {
          shown = shown + remaining;
        } else {
          shown = shown + numToShow;
        }
        if (shown < items) {
          $toggleContainer.find('.toggle-this:lt(' + shown + ')').show(300);
        } else {
          $toggleContainer.find('.toggle-this:lt(' + items + ')').show(300);
          $(this).hide();
        }
      });

      if ($less.length) {
        less.click(function () {
          var hide = items - cutoff;
          $('html, body').animate({
            scrollTop: $toggleContainer.parent().offset().top
          }, 300);
          $toggleContainer.find('.toggle-this').not(':lt(' + cutoff + ')').hide(300);
          $(this).hide();
          $(this).siblings('.view-more').show();
          shown = cutoff;
        });
      }
    });

    ww = window.innerWidth;
  }
});

},{}],18:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $('.m-rez-hero-video button').on('click', function (e) {
    $(this).toggleClass('paused');
    e.preventDefault();
    var videoItem = document.getElementById('hero-video');
    if (videoItem.paused) {
      videoItem.play();
    } else {
      videoItem.pause();
    }
  });

  function calculateHeroFormOverlap() {
    if ($('.m-rez-hero').hasClass('has-form')) {
      var topPad;
      var heroHeight = $('.m-rez-hero').height(),
          formHeight = $('.m-rez-hero-form').height(),
          overHang = heroHeight - formHeight,
          topPad = 130;
    }
  }

  $(window).on('load resize orientationchange', function () {
    if ($('.m-rez-hero').hasClass('has-form')) {
      var topPad;
      setTimeout(function () {
        var heroHeight = $('.m-rez-hero').height(),
            formHeight = $('.m-rez-hero-form').height(),
            overHang = heroHeight - formHeight,
            topPad = 130;
        if (window.innerWidth >= 768) {
          topPad = 250 + overHang;
          // $('.m-rez-hero.has-form').height('65vh')

          if (window.innerWidth >= 992) {
            topPad = 100 + overHang;
            // $('.m-rez-hero.has-form').height('85vh')
          }
          heroHeight = $('.m-rez-hero').height(), formHeight = $('.m-rez-hero-form').height(), overHang = heroHeight - formHeight;
        } else {
          $('.m-rez-hero').height('98vh');
          heroHeight = $('.m-rez-hero').height();
          $('.m-rez-hero.has-form').height(heroHeight + formHeight - 50);
          formHeight = $('.m-rez-hero-form').height();
        }

        // $('.m-rez-hero.has-form + section').css('padding-top', topPad)

        $('.m-rez-hero.has-form textarea').each(function () {
          var offset = this.offsetHeight - this.clientHeight;
          var prevScrollHeight = 53,
              curScrollHeight = 53,
              newHeight = 53;
          var adjustTopPadforTextarea = function adjustTopPadforTextarea(el) {
            curScrollHeight = el.scrollHeight;
            if (curScrollHeight > prevScrollHeight && curScrollHeight > 75) {
              newHeight = el.scrollHeight + offset + 20;
              prevScrollHeight = curScrollHeight;
              topPad = topPad + 22;
              // $('.m-rez-hero.has-form + section').css('padding-top', topPad)
            }
          };
          $(this).on('keyup input', function () {
            adjustTopPadforTextarea(this, topPad);
          });
        });
      }, 500);
    }
  });
});

},{}],19:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $('.m-rez-home-hero-video button').on('click', function (e) {
    $(this).toggleClass('paused');
    e.preventDefault();
    var videoItem = document.getElementById('hero-video');
    if (videoItem.paused) {
      videoItem.play();
    } else {
      videoItem.pause();
    }
  });

  if ($(".m-rez-home-hero-type-out-text").length) {
    var typeOutText = function typeOutText(textElement, callback) {
      var text = textElement.text().trim();
      var typedText = "";
      textElement.html("");
      textElement.css("display", "inline-block").show();

      var cursor = $('<span class="m-rez-home-hero-cursor"></span>');
      textElement.append(cursor);

      var charIndex = 0;
      function typeChar() {
        if (charIndex < text.length) {
          typedText += text[charIndex];
          textElement.html(typedText).append(cursor);
          charIndex++;
          setTimeout(typeChar, typingSpeed);
        } else {
          setTimeout(function () {
            textElement.fadeOut(fadeDuration, callback);
          }, pauseDuration);
        }
      }
      typeChar();
    };

    var loopThroughTexts = function loopThroughTexts() {
      var currentText = $(texts[index]);
      typeOutText(currentText, function () {
        index = (index + 1) % texts.length;
        loopThroughTexts();
      });
    };

    var texts = $(".m-rez-home-hero-type-out-text");
    var typingSpeed = 100;
    var pauseDuration = 2000;
    var fadeDuration = 800;

    var index = 0;

    loopThroughTexts();
  }
});

},{}],20:[function(require,module,exports){
'use strict';

jQuery(function ($) {

  $(window).on('orientationchange resize load', function () {
    var wwidth = $(window).width();
    if (wwidth > 991) {
      // bracketsATextHeight();
    } else {
      $('.m-brackets-a-content').each(function () {
        $(this).css('height', '');
      });
    }
  });
  function bracketsATextHeight() {

    var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = new Array(),
        $el,
        currentDiv = 0,
        topPosition = 0;

    $('.m-brackets-a-content').each(function () {

      $el = $(this);
      topPosition = $el.offset().top;

      if (currentRowStart <= topPosition - 100 || currentRowStart >= topPosition + 100) {

        // we just came to a new row.  Set all the heights on the completed row
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
          rowDivs[currentDiv].height(currentTallest + 26);
        }

        // set the variables for the new row
        rowDivs.length = 0; // empty the array
        currentRowStart = topPosition;
        currentTallest = $el.height();
        rowDivs.push($el);
      } else {

        // another div on the current row.  Add it to the list and check if it's taller
        rowDivs.push($el);
        currentTallest = currentTallest < $el.height() ? $el.height() + 26 : currentTallest;
      }

      // do the last row
      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest + 26);
      }
    });
  }
});

},{}],21:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    bracketsBHeight();
  });
  $(window).on('orientationchange resize', function () {
    bracketsBHeight();
  });

  function bracketsBHeight() {
    $('.m-brackets-b').each(function () {
      var proseH = $(this).find('.m-brackets-b-prose').outerHeight();
      $(this).find('.bg-image').height(proseH);
    });
  }
});

},{}],22:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    billboardCImgPosition();
  });
  $(window).on('orientationchange resize', function () {
    billboardCImgPosition();
  });

  function billboardCImgPosition() {
    var windowW = $(window).innerWidth();
    var containerW = $('.container').width();
    if (windowW >= 768) {
      var margin = -(windowW - containerW) / 2;
      var width = windowW / 2 + 50;
      if (windowW >= 992) {
        width = windowW / 2 - 50;
      }
      $('.m-billboard-c').each(function () {
        var modH = $(this).find('.m-billboard-c-inner').innerHeight();
        modH = modH - 10;
        $(this).find('.m-billboard-c-img-wrapper').css('max-height', modH);

        if ($(this).find('.m-billboard-c-inner').hasClass('m-billboard-c-right')) {
          $(this).find('.m-billboard-c-img-wrapper').width(width).css('margin-right', margin);
        }

        if ($(this).find('.m-billboard-c-inner').hasClass('m-billboard-c-left')) {
          if (windowW >= 768 && windowW < 992) {
            width = windowW / 2 + 20;
          }
          $(this).find('.m-billboard-c-img-wrapper').width(width).css('margin-left', margin);
        }
      });
    }
  }
});

},{}],23:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    twoColTextImgAlign();
  });
  $(window).on('orientationchange resize', function () {
    twoColTextImgAlign();
  });

  function twoColTextImgAlign() {
    var windowW = $(window).innerWidth();
    if (windowW >= 991) {
      $('.m-twocol-text-img-a').each(function () {
        var textH = $(this).find('.m-twocol-text-img-a-text').outerHeight();
        var imgH = $(this).find('.m-twocol-text-img-a-img').outerHeight();
        if (textH < imgH) {
          $(this).find('.row:first').addClass('align-items-lg-center');
        } else {
          $(this).find('.row:first').removeClass('align-items-lg-center');
        }
      });
    }
  }
});

},{}],24:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    twoColTextMediaCHeight();
  });
  $(window).on('orientationchange resize', function () {
    twoColTextMediaCHeight();
  });

  function twoColTextMediaCHeight() {
    var windowW = $(window).innerWidth();
    var containerW = $('.container').width();
    if (windowW >= 991) {
      $('.m-twocol-text-media-c').each(function () {
        var textH = $(this).find('.m-twocol-text-media-c-img-content').outerHeight();
        var contentH = $(this).find('.m-twocol-text-media-c-content').outerHeight();
        var overallImg = $(this).find('.m-twocol-text-media-c-img-bg').outerHeight();
        if (textH <= 300) {
          $(this).find('.m-twocol-text-media-c-img').outerHeight('360px');
        } else {
          if (contentH > overallImg) {
            // if text on left is taller, align img to top
            $(this).find('.row').removeClass('align-items-lg-center');
          }
          $(this).find('.m-twocol-text-media-c-img').outerHeight(textH + 'px');
        }
      });
    } else {
      $('.m-twocol-text-media-c').each(function () {
        var imgTextH = $(this).find('.m-twocol-text-media-c-img-content-text').outerHeight();
        imgTextH = imgTextH + 130;
        $(this).find('.m-twocol-text-media-c-img').outerHeight(imgTextH + 'px');
      });
    }
  }
});

},{}],25:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    twoColTextMediaDTextPadding();
    twoColTextMediaDImgHeight();
  });
  $(window).on('orientationchange resize', function () {
    twoColTextMediaDTextPadding();
    twoColTextMediaDImgHeight();
  });

  function twoColTextMediaDTextPadding() {
    $('.m-twocol-text-media-d').each(function () {
      var windowW = $(window).innerWidth();
      var containerW = $('.container').width();
      var gutter = (windowW - containerW) / 2 - 30;
      if ($(window).innerWidth() >= 992) {
        $(this).find('.m-twocol-text-media-d-content-wrapper').css('padding-left', gutter);
      }
      if ($(window).innerWidth() <= 576) {
        $(this).find('.m-twocol-text-media-d-content-wrapper').css('padding-left', '15px');
      }
    });
  }

  function twoColTextMediaDImgHeight() {
    $('.m-twocol-text-media-d').each(function () {
      var textH = $(this).find('.m-twocol-text-media-d-text-side').height();
      var imgH = $(this).find('.m-twocol-text-media-d-img-side').height();
      if ($(window).innerWidth() >= 992) {
        if (textH <= 300) {
          $(this).find('.img-rectangle-4-3').css('padding-top', '50%');
        } else {
          $(this).find('.img-rectangle-4-3').css('padding-top', '65%');
        }
      }
    });
  }
});

},{}],26:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    twoColTextListAPosition();
  });
  $(window).on('orientationchange resize', function () {
    twoColTextListAPosition();
  });

  $(window).scroll(function () {
    var scrollTop = $(this).scrollTop();
    $('.m-twocol-text-list-a').each(function () {
      var totalHeight = $(this).innerHeight();
      var elPosition = $(this).offset().top;
      if ($(window).innerWidth() >= 768) {
        if (scrollTop >= elPosition) {
          $(this).find('.bg-image').addClass('fixed');
          $(this).find('.container').addClass('relative');
        } else {
          $(this).find('.container').removeClass('relative');
          $(this).find('.bg-image').removeClass('fixed');
        }
      }
    });
  }).scroll();

  function twoColTextListAPosition() {
    var windowW = $(window).innerWidth();
    var containerW = $('.container').width();
    if (windowW >= 768) {
      var margin = -(windowW - containerW) / 2 + 30 - 30;
      var width = windowW / 2 - 50;
      if (windowW >= 992) {
        width = windowW / 2 - 190;
      }
      if (windowW >= 1500) {
        width = windowW / 2 - 300;
      }
      $('.m-twocol-text-list-a').each(function () {
        var modH = $(this).find('.m-twocol-text-list-a-list-wrapper').innerHeight();
        modH = modH + 160;
        $(this).find('.container').css('height', modH);
        $(this).find('.bg-image').css('height', modH);

        $(this).find('.m-twocol-text-list-a-list-wrapper').width(width).css('margin-right', margin);
      });
    }
  }
});

},{}],27:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    // twoColTextListB()
  });
  $(window).on('orientationchange resize', function () {
    // twoColTextListB()
  });

  $(window).scroll(function () {
    var windowH = $(window).innerHeight();
    var scrollTop = $(this).scrollTop();
    $('.m-twocol-text-list-b').each(function () {
      var totalListItems = $(this).find('ul li').length;

      var midPosition = $(this).find('ul li:nth-of-type(1)').offset().top;
      if ($(window).innerWidth() >= 768) {
        if (totalListItems > 5) {
          midPosition = $(this).find('ul li:nth-of-type(6)').offset().top;
        }
        var listH = $(this).find('.m-twocol-text-list-b-list-wrapper').outerHeight();
        listH = listH + 30;
        var leftH = $(this).find('.m-twocol-text-list-b-left-wrapper').height();

        if (listH > leftH) {
          $(this).find('.m-twocol-text-list-b-left-wrapper').removeClass('mt-md-5').addClass('mt-md-0');
        }
      }
      if ($(window).innerWidth() >= 992) {
        if (totalListItems > 3) {
          midPosition = $(this).find('ul li:nth-of-type(4)').offset().top;
        }
      }
      var midDistance = midPosition - scrollTop;
      var lastPosition = $(this).find('ul li:last-of-type').offset().top;
      var lastHeight = $(this).find('ul li:last-of-type').height();
      var lastDistance = lastPosition - scrollTop + lastHeight + lastHeight / 2;
      $(this).find('li').each(function () {
        var elPosition = $(this).offset().top;
        var elHeight = $(this).height();
        var elPDistance = elPosition - scrollTop + elHeight;
        if (elPDistance <= windowH) {
          $(this).addClass('in');
        } else {
          $(this).removeClass('in');
        }
      });
      if (midDistance <= windowH) {
        $(this).find('.edge-pattern.edge-pattern-bottom').addClass('in');

        if (lastDistance <= windowH) {
          $(this).find('.edge-pattern.edge-pattern-bottom').addClass('absolute');
          $(this).find('.m-twocol-text-list-b-list-wrapper').addClass('ontop');
        } else {
          $(this).find('.edge-pattern.edge-pattern-bottom').removeClass('absolute');
          $(this).find('.m-twocol-text-list-b-list-wrapper').removeClass('ontop');
        }
      } else {
        $(this).find('.edge-pattern.edge-pattern-bottom').removeClass('in absolute');
      }
    });
  }).scroll();
});

},{}],28:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    twoColTextStatsHeight();
  });
  $(window).on('orientationchange resize', function () {
    twoColTextStatsHeight();
  });

  function twoColTextStatsHeight() {
    var windowW = $(window).innerWidth();
    var containerW = $('.container').width();

    $('.m-twocol-text-stats').each(function () {
      var statsH = $(this).find('.m-twocol-text-stats-img-content').height();
      if (windowW >= 768) {
        if (statsH <= 300) {
          $(this).find('.m-twocol-text-stats-img-wrapper').height('300px');
        } else {
          var newH = statsH;
          $(this).find('.m-twocol-text-stats-img-wrapper').height(newH + 'px');
        }

        // vertically align text with img if text is smaller
        if (windowW >= 991) {
          var statsContent = $(this).find('.m-twocol-text-stats-content').outerHeight();
          var imgContent = $(this).find('.m-twocol-text-stats-img-bg').outerHeight();
          if (imgContent > statsContent) {
            $(this).find('.row').first().addClass('align-center');
          } else {
            $(this).find('.row').first().removeClass('align-center');
          }
        }
      } else {
        var newH = statsH;
        $(this).find('.m-twocol-text-stats-img-wrapper').height(newH + 'px');
      }
    });
  }
});

},{}],29:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    twoColWysiwygBContainer();
    twoColWysiwygBLeftHeight();
  });
  $(window).on('orientationchange resize', function () {
    twoColWysiwygBContainer();
    twoColWysiwygBLeftHeight();
  });

  $(window).scroll(function () {
    var scrollTop = $(this).scrollTop();
    $('.m-two-col-wysiwyg-b').each(function () {
      var totalHeight = $(this).innerHeight();
      var elPosition = $(this).offset().top;
      if ($(window).innerWidth() >= 768) {
        if (scrollTop >= elPosition + 78) {
          $(this).find('.m-two-col-wysiwyg-b-left-bg').addClass('fixed');
          $(this).find('.m-two-col-wysiwyg-b-left-content').addClass('box-me');
        } else {
          $(this).find('.m-two-col-wysiwyg-b-left-content').removeClass('box-me');
          $(this).find('.m-two-col-wysiwyg-b-left-bg').removeClass('fixed');
        }
      }
    });
  }).scroll();

  function twoColWysiwygBLeftHeight() {
    $('.m-two-col-wysiwyg-b').each(function () {
      var leftContentH = $(this).find('.m-two-col-wysiwyg-b-left-content').outerHeight();
      var leftW = $(this).find('.m-two-col-wysiwyg-b-left').width();
      console.log(leftW);
      $(this).find('.m-two-col-wysiwyg-b-left, .m-two-col-wysiwyg-b-left-bg, .m-two-col-wysiwyg-b-left .bg-image').height(leftContentH);
      $(this).find('.m-two-col-wysiwyg-b-left-bg').width(leftW);
      $(this).next('.parallax-border-radius').width(leftW);
    });
  }

  function twoColWysiwygBContainer() {
    var windowW = $(window).innerWidth();
    var containerW = $('.container').width();
    $('.m-two-col-wysiwyg-b').each(function () {
      if (windowW > 1400) {
        var margin = (windowW - containerW) / 2 + 30 - 15;
        $(this).find('.m-two-col-wysiwyg-b-left-content').css('padding-left', margin + 'px');
        $(this).find('.m-two-col-wysiwyg-b-right-content').css('padding-right', margin + 'px');
      } else {
        $(this).find('.m-two-col-wysiwyg-b-left-content').css('padding-left', '30px');
        $(this).find('.m-two-col-wysiwyg-b-right-content').css('padding-right', '30px');
      }
    });
  }
});

},{}],30:[function(require,module,exports){
'use strict';

$(document).ready(function () {
  slickThisLogosB();
});
$(window).on('resize orientationchange', function () {
  slickThisLogosB();
});

function slickThisLogosB() {
  var wwidth = $(window).width();
  $('.m-logos-b-logos.slick-this-logos:not(.slick-initialized)').each(function () {
    var logoCount = $(this).find('.m-logos-b-logo').length;
    if (logoCount < 5) {
      $(this).addClass('under-five');
    }
    if (logoCount > 3) {
      if (wwidth <= 991 || logoCount > 5) {
        var adaptiveHeight = $(this).data('height'),
            arrows = $(this).data('arrows'),
            autoplay = $(this).data('autoplay'),
            dots = $(this).data('dots'),
            fade = $(this).data('fade'),

        // slidesToScroll = $(this).data('scroll'),
        // slidesToShow = $(this).data('show')
        //$arrows = $(this).siblings('.m-slider-arrows')
        slidesToScrollMobile = 2;
        if (logoCount > 10) {
          slidesToScrollMobile = 3;
        }
        $(this).slick({
          adaptiveHeight: adaptiveHeight,
          arrows: arrows,
          autoplay: autoplay,
          dots: dots,
          fade: fade,
          infinite: true,
          mobileFirst: true,
          rows: 0,
          slidesToScroll: slidesToScrollMobile,
          slidesToShow: slidesToScrollMobile,
          autoplaySpeed: 1,
          speed: 20000,
          cssEase: 'linear',
          waitForAnimate: false,
          pauseOnFocus: false,
          pauseOnHover: false,

          responsive: [{
            breakpoint: 567,
            settings: {
              dots: true,
              arrows: false,
              slidesToScroll: 3,
              slidesToShow: 3
            }
          }, {
            breakpoint: 767,
            settings: {
              dots: false,
              arrows: true,
              slidesToScroll: 3,
              slidesToShow: 3
            }
          }, {
            breakpoint: 991,
            settings: {
              slidesToScroll: 5,
              slidesToShow: 5
            }
          }]
        });
      }
    }
  });
}

},{}],31:[function(require,module,exports){
'use strict';

jQuery(function ($) {

  $(window).on('resize orientationchange', function () {
    $('.m-quotes-a-slides.slick-intialized').slick('unslick');
    slickThis();
  });

  function slickThis() {
    $('.slick-this:not(.slick-initialized)').each(function () {
      var adaptiveHeight = $(this).data('height'),
          arrows = $(this).data('arrows'),
          autoplay = $(this).data('autoplay'),
          dots = $(this).data('dots'),
          fade = $(this).data('fade'),
          slidesToScroll = $(this).data('scroll'),
          slidesToShow = $(this).data('show');
      //$arrows = $(this).siblings('.m-slider-arrows')

      $(this).slick({
        adaptiveHeight: adaptiveHeight,
        arrows: arrows,
        autoplay: autoplay,
        dots: dots,
        fade: fade,
        infinite: false,
        mobileFirst: true,
        //nextArrow: $arrows.find('.m-slider-arrows-arrow-right'),
        //prevArrow: $arrows.find('.m-slider-arrows-arrow-left'),
        rows: 0,
        slidesToScroll: slidesToScroll,
        slidesToShow: slidesToShow
      });
    });
  }
});

},{}],32:[function(require,module,exports){
'use strict';

jQuery(function ($) {

  $(window).on('resize orientationchange', function () {
    $('.m-quotes-b-slides.slick-intialized').slick('unslick');
    slickThis();
  });
  function slickThis() {
    $('.slick-this:not(.slick-initialized)').each(function () {
      var adaptiveHeight = $(this).data('height'),
          arrows = $(this).data('arrows'),
          autoplay = $(this).data('autoplay'),
          dots = $(this).data('dots'),
          fade = $(this).data('fade'),
          slidesToScroll = $(this).data('scroll'),
          slidesToShow = $(this).data('show');
      //$arrows = $(this).siblings('.m-slider-arrows')

      $(this).slick({
        adaptiveHeight: adaptiveHeight,
        arrows: arrows,
        autoplay: autoplay,
        dots: dots,
        fade: fade,
        infinite: false,
        mobileFirst: true,
        //nextArrow: $arrows.find('.m-slider-arrows-arrow-right'),
        //prevArrow: $arrows.find('.m-slider-arrows-arrow-left'),
        rows: 0,
        slidesToScroll: slidesToScroll,
        slidesToShow: slidesToShow
      });
    });
  }
});

},{}],33:[function(require,module,exports){
'use strict';

jQuery(function ($) {

  $(window).on('load', function () {
    if ($('.m-related-reading-c-slider').length) {
      slickThis();
    }
  });

  $(window).on('resize orientationchange', function () {
    $('.m-related-reading-c-slider.slick-intialized').slick('unslick');
    slickThis();
  });

  function slickThis() {
    $('.m-related-reading-c-slider:not(.slick-initialized)').each(function () {
      $(this).slick({
        adaptiveHeight: true,
        arrows: true,
        autoplay: false,
        dots: true,
        fade: true,
        infinite: true,
        mobileFirst: true,
        nextArrow: $('.m-related-reading-c-slider-arrows-arrow-right'),
        prevArrow: $('.m-related-reading-c-slider-arrows-arrow-left'),
        appendDots: $('.m-related-reading-c-slider-dots'),
        rows: 0,
        slidesToScroll: 1,
        slidesToShow: 1
      });
    });
  }
});

},{}],34:[function(require,module,exports){
'use strict';

jQuery(function ($) {

  $(window).on('resize orientationchange', function () {
    if ($(window).innerWidth() < 768) {
      $('.m-featured-insights-carousel-mobile').slick('resize');
    }
    slickMe();
    cardHeight();
  });
  $(document).ready(function () {
    slickMe();
    cardHeight();
  });
  $(window).on('load', function () {
    // textSize()
  });

  function cardHeight() {
    $('.m-featured-insights').each(function () {
      var maxHeight = Math.max.apply(null, $(this).find('.card-featured').map(function () {
        return $(this).height();
      }).get());
      var newHeight = maxHeight + 30;
      $(this).find('.card-featured').css('height', maxHeight);

      if ($(window).innerWidth() >= 768) {
        var modHeight = newHeight + 10;
        $(this).find('.m-featured-insights-carousel').css('height', modHeight);
      } else {
        $(this).find('.m-featured-insights-carousel').css('height', 'auto');
      }
    });
  }

  $('.m-featured-insights').each(function () {
    var $btnNext = $(this).find('.btn-next');
    var $btnPrev = $(this).find('.btn-prev');
    var $position2 = $('.position-2');
    var $position3 = $('.position-3');
    $btnNext.on('click', function () {
      $('.active-slide').addClass('active-transition').addClass('prev-slide');
      setTimeout(function () {
        $('.active-transition').removeClass('active-slide active-transition');
        $('.position-2:not(.next-slide)').removeClass('position-2').addClass('active-slide');
        $('.position-3:not(.prev-slide)').removeClass('position-3').addClass('next-slide');
        $('.next-slide').addClass('position-2').removeClass('next-slide');
        $('.prev-slide').addClass('position-3').removeClass('prev-slide');
      }, 100);
    });
    $btnPrev.on('click', function () {
      $('.active-slide').addClass('active-transition').addClass('next-slide');
      setTimeout(function () {
        $('.active-transition').removeClass('active-slide active-transition');
        $('.position-2:not(.prev-slide)').removeClass('position-2').addClass('prev-slide');
        $('.position-3:not(.next-slide)').removeClass('position-3').addClass('active-slide');
        $('.next-slide').addClass('position-2').removeClass('next-slide');
        $('.prev-slide').addClass('position-3').removeClass('prev-slide');
      }, 100);
    });
  });

  function slickMe() {
    if ($(window).innerWidth() < 768) {
      $('.m-featured-insights-carousel-mobile:not(.slick-initialized)').each(function () {
        var adaptiveHeight = $(this).data('height'),
            arrows = $(this).data('arrows'),
            autoplay = $(this).data('autoplay'),
            dots = $(this).data('dots'),
            fade = $(this).data('fade'),
            slidesToScroll = $(this).data('scroll'),
            slidesToShow = $(this).data('show');

        $(this).slick({
          adaptiveHeight: adaptiveHeight,
          arrows: arrows,
          autoplay: autoplay,
          dots: dots,
          fade: fade,
          infinite: true,
          mobileFirst: true,
          //nextArrow: $arrows.find('.m-slider-arrows-arrow-right'),
          //prevArrow: $arrows.find('.m-slider-arrows-arrow-left'),
          rows: 0,
          slidesToScroll: 1,
          slidesToShow: 1,
          initialSlide: 0,
          centerMode: true,
          centerPadding: '40px',
          cssEase: 'ease-in',
          responsive: [{
            breakpoint: 567,
            settings: {
              dots: true,
              arrows: false,
              centerPadding: '80px'
            }
          }]
        });
      });
    } else {
      $('.m-featured-insights-carousel-mobile.slick-initialized').slick('unslick');
    }
  }
});

},{}],35:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    boxOverlap();
  });
  $(document).on('load', function () {
    boxOverlap();
  });
  $(window).on('resize orientationchange', function () {
    boxOverlap();
  });
  var headerHeight = $('.m-header').height();

  function boxOverlap() {
    var containerWidth = $('.container').width(),
        ww = window.innerWidth,
        leftMargin = (ww - containerWidth) / -2;
    $('.m-full-width-img-content').each(function () {
      var boxHeight = $(this).find('.m-full-width-img-content-box').outerHeight();
      var topMargin = 230,
          boxTop = 230,
          bottomExtra,
          boxContainer,
          bottom,
          height;
      if (window.innerWidth >= 768 && window.innerWidth < 992) {
        leftMargin = (ww - containerWidth) / -2 - 15;
        if (boxHeight < 300) {
          boxTop = boxHeight / 1.5;
          // bottomExtra = 80
          boxContainer = 450;
          // height = 450
          bottom = -340;
          $(this).find('.m-full-width-img-content-box').css({ 'top': 'auto', 'bottom': bottom + 'px' });
        } else {
          boxTop = 220;
          boxContainer = boxHeight + boxTop;
          $(this).find('.m-full-width-img-content-box').css('top', boxTop + 'px');
        }
        $(this).find('.m-full-width-img-content-box-wrapper').height(boxContainer);
      } else if (window.innerWidth >= 992) {
        leftMargin = (ww - containerWidth) / -2 - 15;
        if (boxHeight < 400) {
          boxTop = boxHeight / 1.5;
          boxContainer = 550;
          bottom = -380;
          $(this).find('.m-full-width-img-content-box').css({ 'top': 'auto', 'bottom': bottom + 'px' });
          $(this).find('.m-full-width-img-content-box-overhang').css('height', boxTop + 'px');
        } else {
          boxTop = 260;
          boxContainer = boxHeight + boxTop;
          $(this).find('.m-full-width-img-content-box').css('top', boxTop + 'px');
          $(this).find('.m-full-width-img-content-box-overhang').css('height', boxTop + 'px');
        }
        $(this).find('.m-full-width-img-content-box-wrapper').height(boxContainer);
      } else {
        leftMargin = -15;
        boxTop = 160;
        boxContainer = boxHeight + boxTop + 50;
        $(this).find('.m-full-width-img-content-box').css('top', boxTop + 'px');
        $(this).find('.m-full-width-img-content-box-wrapper').height(boxContainer);
      }

      if ($(this).find('.m-full-width-img-content-box').hasClass('box-right')) {
        $(this).find('.m-full-width-img-content-box-overhang').css('right', leftMargin);
      } else {
        $(this).find('.m-full-width-img-content-box-overhang').css('left', leftMargin);
      }
    });
  }

  $(window).scroll(function () {
    var topPos;
    var scrollTop = $(this).scrollTop();
    $('.m-full-width-img-content').each(function () {
      var topPad = 0;
      if (window.innerWidth >= 992) {
        headerHeight = $('.m-header.condensed').height();
        topPos = headerHeight;
      } else {
        topPos = 0;
        headerHeight = 0;
      }
      var elPosition = $(this).offset().top;
      elPosition = elPosition - topPos;
      if (scrollTop >= elPosition) {
        $(this).find('.bg-image').addClass('fixed').css('top', headerHeight + 'px');
      } else {
        $(this).find('.bg-image').removeClass('fixed').css('top', 'initial');
      }
    });
  }).scroll();
});

},{}],36:[function(require,module,exports){
'use strict';

jQuery(function ($) {
    $(document).ready(function () {

        if ($('.m-accordions').length) {
            $('.m-accordions').each(function () {
                var $accordion = $(this);

                $accordion.find('.accordion-content').hide();

                $accordion.find('.accordion-header').first().addClass("open").next('.accordion-content').show();

                $accordion.find('.accordion-header').on('click', function (e) {
                    e.preventDefault();

                    if (!$(this).hasClass("open")) {
                        $accordion.find('.accordion-header.open').removeClass("open").next('.accordion-content').slideUp();
                    }

                    $(this).toggleClass("open");
                    $(this).next('.accordion-content').slideToggle();
                });
            });
        }
    });
});

},{}],37:[function(require,module,exports){
'use strict';

jQuery(function ($) {
    if (!$.easing.easeInOutQuad) {
        $.easing.easeInOutQuad = function (t) {
            return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
        };
    }

    $('.m-solutions-filter-filters-list a').on('click', function (event) {
        event.preventDefault();

        var industrySlug = $(this).data('value');
        var industryHref = $(this).attr('href');
        var articleContainer = $('.m-solutions-filter-container-articles');
        var viewAllButton = $('.m-solutions-filter-container-button a');
        var loading = $('.loading');
        var filterContainer = $('.m-solutions-filter-container');
        var minLoadingTime = 400;
        var requestStartedAt;

        function scrollToFilterContainer() {
            if (!filterContainer.length) {
                return;
            }

            // html has `scroll-behavior: smooth` (see _base.scss), which hijacks
            // jQuery's incremental scrollTop writes with its own fast native easing.
            // Disable it for the duration of this animation so our timing/easing apply.
            var htmlEl = document.documentElement;
            var previousScrollBehavior = htmlEl.style.scrollBehavior;
            htmlEl.style.scrollBehavior = 'auto';

            $('html, body').animate({
                scrollTop: filterContainer.offset().top
            }, 800, 'easeInOutQuad', function () {
                htmlEl.style.scrollBehavior = previousScrollBehavior;
            });
        }

        function finishLoading(callback) {
            var elapsed = Date.now() - requestStartedAt;
            var remaining = Math.max(minLoadingTime - elapsed, 0);

            setTimeout(function () {
                loading.hide();
                callback();
                scrollToFilterContainer();
            }, remaining);
        }

        $.ajax({
            url: 'https://' + window.location.host + '/wp-json/rez/posts-w-industries?industry=' + industrySlug,
            type: 'GET',
            beforeSend: function beforeSend() {
                requestStartedAt = Date.now();
                loading.show();
            },
            success: function success(response) {
                var content = '';
                if (response.length) {
                    content = response;
                } else {
                    content = '<p>No related articles found.</p>';
                }

                finishLoading(function () {
                    articleContainer.html(content);
                    viewAllButton.attr('href', industryHref);
                });
            },
            error: function error() {
                finishLoading(function () {
                    articleContainer.html('<p>Error fetching posts. Please try again.</p>');
                });
            }
        });
    });
});

},{}],38:[function(require,module,exports){
'use strict';

// Quiz configuration and state management
var quizState = {
  currentStep: -1, // Start with intro page
  answers: {},
  introAnswer: null, // Separate storage for intro question
  contactInfo: {
    name: '',
    company: '',
    email: '',
    phone: '',
    role: '',
    companySize: '',
    industrySubsector: '',
    dataSystems: ''
  },
  showResults: false,
  formSubmitted: false
};

// Introductory question (not scored)
var introQuestion = {
  id: 'state_focus',
  text: 'What is your state most focused on right now?',
  options: ['Child care supply mapping', 'Data integration across programs', 'Fiscal transparency and reporting', 'Provider workforce data', 'Family search tools', 'CCR&R case management systems']
};

// Quiz questions configuration (these are scored)
var questions = [{
  id: 'data_integration_interoperability',
  headline: 'Data Integration & Interoperability',
  text: 'Do your systems automatically receive data from any child care provider software (CCMS platforms)?',
  options: ['Yes, we integrate with multiple provider systems and receive a range of data automatically', 'We have a single system providers can opt into that shares limited data', 'No, data is not integrated today', 'I\'m not sure'],
  points: [3, 2, 1, 0]
}, {
  id: 'whole_child_view',
  headline: 'The "Whole Child" View',
  text: 'Can your state see a connected view of a child across programs like Child Care Subsidy, Public Pre-K, and Part B/C?',
  options: ['Yes, we can see a connected cross-program view of children to understand who is being served and how programs work together', 'Some systems are connected, but a full view is difficult to access', 'No, systems operate separately', 'I\'m not sure'],
  points: [3, 2, 1, 0]
}, {
  id: 'workforce_stability',
  headline: 'Workforce Stability',
  text: 'Can you connect workforce data (teacher credentials, turnover, etc.) to provider participation in subsidy programs?',
  options: ['Yes, we track this through dashboards or integrated systems', 'We analyze this manually through reports', 'No visibility today', 'I\'m not sure'],
  points: [3, 2, 1, 0]
}, {
  id: 'roi_fiscal_transparency',
  headline: 'ROI & Fiscal Transparency',
  text: 'Can your state connect track early childhood funding to an impact on outcomes such as functional increase in supply or relative to demand or kindergarten readiness?',
  options: ['Yes, we track this regularly through dashboards or automated reports', 'We create or fund reports when we want to see this data', 'No, funding and outcomes are tracked separately', 'I\'m not sure'],
  points: [3, 2, 1, 0]
}, {
  id: 'real_time_monitoring',
  headline: 'Real-Time Monitoring',
  text: 'Can leadership see live or near-live data on child care supply, demand, and utilization across the state?',
  options: ['Yes, through dashboards or automated systems', 'We produce periodic reports, but not in real time', 'No, we rely on annual or ad hoc analysis', 'I\'m not sure'],
  points: [3, 2, 1, 0]
}, {
  id: 'predictive_analytics',
  headline: 'Predictive Analytics',
  text: 'Can your state anticipate child care supply gaps 6–12 months in advance?',
  options: ['Yes, we use data models or dashboards to forecast supply gaps', 'We use periodic modeling or surveys', 'No, we rely on historical data only', 'I\'m not sure'],
  points: [3, 2, 1, 0]
}, {
  id: 'data_governance_security',
  headline: 'Data Governance & Security',
  text: 'Do you have formal data-sharing agreements (like MOUs) that support cross-agency data use?',
  options: ['Yes, we have clear agreements that enable efficient data sharing', 'Some agreements exist, but they are inconsistent or manual', 'Not formal agreements in place', 'I\'m not sure'],
  points: [3, 2, 1, 0]
}, {
  id: 'provider_capacity_access',
  headline: 'Provider Capacity & Access',
  text: 'Can you view child care supply and demand by specific geographic breakdowns (zip code, city, county), including real-time vacancies?',
  options: ['Yes, we use dashboards or maps with near real-time data', 'We rely on periodic reports or surveys', 'No, this visibility does not exist today', 'I\'m not sure'],
  points: [3, 2, 1, 0]
}];

// Function to update progress bar
function updateProgressBar() {
  var totalSteps = questions.length;
  // Adjust for intro question at step 0 - only count actual quiz questions
  var currentStep = quizState.currentStep > 0 ? quizState.currentStep : 0;
  var progressPercent = quizState.currentStep > 0 ? currentStep / totalSteps * 100 : 0;

  var progressBar = document.querySelector('.progress-bar');
  if (progressBar) {
    // Hide progress bar if progress is 0%
    if (progressPercent === 0) {
      progressBar.style.opacity = '0';
      progressBar.style.visibility = 'hidden';
    } else {
      progressBar.style.opacity = '1';
      progressBar.style.visibility = 'visible';
    }

    var progress = progressBar.querySelector('.progress');
    if (progress) {
      progress.style.width = progressPercent + '%';
    }

    // Add or update percentage display
    var percentDisplay = progressBar.querySelector('.percent-display');
    if (!percentDisplay) {
      percentDisplay = document.createElement('div');
      percentDisplay.className = 'percent-display';
      progressBar.appendChild(percentDisplay);
    }

    // Update the percentage text
    percentDisplay.textContent = Math.round(progressPercent) + '%';
  }
}

// Quiz functionality
function handleAnswer(questionId, value, isMultiselect) {
  if (isMultiselect) {
    // Initialize as array if not exists
    if (!Array.isArray(quizState.answers[questionId])) {
      quizState.answers[questionId] = [];
    }

    var index = quizState.answers[questionId].indexOf(value);
    if (index === -1) {
      // Add value if not present
      quizState.answers[questionId].push(value);
    } else {
      // Remove value if present
      quizState.answers[questionId].splice(index, 1);
    }
  } else {
    quizState.answers[questionId] = value;
  }

  updateQuizDisplay();
  updateProgressBar();
}

function handleNext() {
  // Special case for intro page - handled in updateQuizDisplay
  if (quizState.currentStep === -1) {
    return;
  }

  // For scored questions (steps 1-8), adjust index by -1
  var questionIndex = quizState.currentStep - 1;
  var currentQuestion = questions[questionIndex];
  var currentAnswer = quizState.answers[currentQuestion.id];

  if (!currentAnswer || Array.isArray(currentAnswer) && currentAnswer.length === 0) {
    alert('Please select at least one option before continuing.');
    return;
  }

  // Check if we've reached the last scored question
  if (quizState.currentStep < questions.length) {
    quizState.currentStep++;
    updateQuizDisplay();
    updateProgressBar();
  } else {
    showResults();
  }
}

function handlePrevious() {
  if (quizState.currentStep > -1) {
    quizState.currentStep--;
    updateQuizDisplay();
    updateProgressBar();
  }
}

function handleInputChange(event) {
  var _event$target = event.target,
      name = _event$target.name,
      value = _event$target.value;

  quizState.contactInfo[name] = value;
}

function isOptionSelected(questionId, optionValue) {
  var answer = quizState.answers[questionId];
  if (!answer) return false;

  if (Array.isArray(answer)) {
    // For multiselect questions (checkboxes)
    return answer.includes(optionValue);
  } else {
    // For single select questions (radio buttons)
    return answer === optionValue;
  }
}

function updateQuizDisplay() {
  var quizContent = document.querySelector('.quiz-content-childhood');
  if (!quizContent) return;

  // Clear any existing selected classes
  var existingOptions = quizContent.querySelectorAll('.option');
  existingOptions.forEach(function (option) {
    return option.classList.remove('selected');
  });

  if (quizState.showResults) {
    renderResults(quizContent);
    return;
  }

  var container = quizContent.querySelector('.quiz-container-childhood');

  // Update progress bar
  updateProgressBar();

  // Special case for intro page (currentStep = -1)
  if (quizState.currentStep === -1) {
    // Display the intro question alongside intro content
    var introQuestionOptionsHtml = '';

    introQuestion.options.forEach(function (option, index) {
      var isChecked = quizState.introAnswer === option ? 'checked' : '';
      var isSelected = quizState.introAnswer === option ? 'selected' : '';

      introQuestionOptionsHtml += '\n        <div class="option ' + isSelected + '">\n          <input type="radio"\n                 name="' + introQuestion.id + '"\n                 value="' + option + '"\n                 id="' + introQuestion.id + '_' + index + '"\n                 ' + isChecked + '>\n          <label for="' + introQuestion.id + '_' + index + '">' + option + '</label>\n        </div>\n      ';
    });

    container.innerHTML = '\n      <div class="quiz-step quiz-intro">\n        <div class="intro-container">\n          <div class="intro-content">\n            <p><b>Does your child care system give you a clear picture of supply, access, funding, and outcomes? Or does it leave gaps you have to fill in manually?</b></p>\n            <p>This two-minute assessment helps state leaders understand how effectively their early childhood data systems support decision-making.</p>\n            <p>Once complete, you\'ll receive a personalized recommendation for your top focus area.</p>\n            <p>In just a few questions, we\'ll help you uncover how connected, visible, and actionable your data is and where to focus next to improve supply planning, coordination, and impact.</p>\n          </div>\n          <div class="first-question">\n            <div class="quiz-question">\n              <h3>' + introQuestion.text + '</h3>\n              <div class="options">\n                ' + introQuestionOptionsHtml + '\n              </div>\n            </div>\n            <div class="navigation intro-nav">\n              <button type="button" class="next-btn">Next</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    ';

    // Add event listeners for the intro question options
    addOptionEventListeners(container.querySelectorAll('.first-question .option'));

    // Add event listener for the Next button
    container.querySelector('.next-btn').addEventListener('click', function () {
      if (!quizState.introAnswer) {
        alert('Please select an option before continuing.');
        return;
      }

      quizState.currentStep = 1; // Move directly to first scored question (step 1)
      updateQuizDisplay();
    });

    return;
  }

  // For steps 1 and beyond, adjust index by -1
  var questionIndex = quizState.currentStep - 1;
  var question = questions[questionIndex];

  // Check if question is defined before proceeding
  if (!question) {
    console.error('Question is undefined for step:', quizState.currentStep);
    return;
  }

  var savedAnswer = quizState.answers[question.id];

  var optionsHtml = '';
  question.options.forEach(function (option, index) {
    var isChecked = '';
    var isSelected = '';

    if (question.type === 'multiselect') {
      // For multiselect, savedAnswer is an array
      var savedAnswers = Array.isArray(savedAnswer) ? savedAnswer : [];
      isChecked = savedAnswers.includes(option) ? 'checked' : '';
      isSelected = savedAnswers.includes(option) ? 'selected' : '';
    } else {
      // For single select
      isChecked = savedAnswer === option ? 'checked' : '';
      isSelected = savedAnswer === option ? 'selected' : '';
    }

    optionsHtml += '\n      <div class="option ' + isSelected + '">\n        <input type="' + (question.type === 'multiselect' ? 'checkbox' : 'radio') + '"\n               name="' + question.id + '"\n               value="' + option + '"\n               id="' + question.id + '_' + index + '"\n               ' + isChecked + '>\n        <label for="' + question.id + '_' + index + '">' + option + '</label>\n      </div>\n    ';
  });

  container.innerHTML = '\n    <div class="quiz-step">\n      <div class="quiz-question">\n        ' + (question.headline ? '<p class="prehead">' + question.headline + '</p>' : '') + '\n        <h3>' + question.text + '</h3>\n        <div class="options">\n          ' + optionsHtml + '\n        </div>\n      </div>\n      <div class="navigation">\n        ' + (quizState.currentStep > 0 ? '<button type="button" class="prev-btn">Previous</button>' : '') + '\n        <button type="button" class="next-btn">\n          ' + (quizState.currentStep === questions.length ? 'Submit' : 'Next') + '\n        </button>\n      </div>\n    </div>\n  ';

  // Add event listeners
  container.querySelector('.next-btn').addEventListener('click', handleNext);
  if (quizState.currentStep > 0) {
    container.querySelector('.prev-btn').addEventListener('click', handlePrevious);
  }

  var options = container.querySelectorAll('.option');
  options.forEach(function (option) {
    var input = option.querySelector('input');

    // Only handle clicks on the option div itself
    option.addEventListener('click', function (event) {
      // Prevent handling if the click was on the input or label
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'LABEL') {
        return;
      }

      if (input) {
        var isMultiselect = input.type === 'checkbox';

        // Manually toggle the checkbox state
        if (isMultiselect) {
          input.checked = !input.checked;
          // Dispatch change event manually
          input.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });

    // Handle input changes
    input.addEventListener('change', function (event) {
      var questionId = input.getAttribute('name');
      var isMultiselect = input.type === 'checkbox';

      // Update visual state
      if (isMultiselect) {
        option.classList.toggle('selected', input.checked);
      } else {
        var allOptions = option.closest('.options').querySelectorAll('.option');
        allOptions.forEach(function (opt) {
          return opt.classList.remove('selected');
        });
        option.classList.add('selected');
      }

      // Update quiz state
      handleAnswer(questionId, input.value, isMultiselect);
    });
  });
}

function addOptionEventListeners(options) {
  options.forEach(function (option) {
    option.addEventListener('click', function () {
      var input = this.querySelector('input');
      var questionId = input.name;
      var value = input.value;
      var isMultiselect = input.type === 'checkbox';

      // Handle intro content fade out if this is the intro question
      if (quizState.currentStep === -1) {
        var introContent = document.querySelector('.intro-content');
        var firstQuestion = document.querySelector('.first-question');

        if (introContent && firstQuestion) {
          // Add hide-intro class to fade out the intro content
          introContent.classList.add('hide-intro');

          // Make the first question take full width
          firstQuestion.classList.add('full-width');
        }

        // For intro question, store in introAnswer
        if (questionId === introQuestion.id) {
          var allOptions = document.querySelectorAll('input[name="' + questionId + '"]');
          allOptions.forEach(function (opt) {
            opt.checked = false;
            opt.closest('.option').classList.remove('selected');
          });

          quizState.introAnswer = value;
          this.classList.add('selected');
          input.checked = true;
          return;
        }
      }

      if (isMultiselect) {
        // For multiselect, toggle the selection
        if (!quizState.answers[questionId]) {
          quizState.answers[questionId] = [];
        }

        var index = quizState.answers[questionId].indexOf(value);
        if (index === -1) {
          quizState.answers[questionId].push(value);
          this.classList.add('selected');
          input.checked = true;
        } else {
          quizState.answers[questionId].splice(index, 1);
          this.classList.remove('selected');
          input.checked = false;
        }
      } else {
        // For single select, clear other selections
        var _allOptions = document.querySelectorAll('input[name="' + questionId + '"]');
        _allOptions.forEach(function (opt) {
          opt.checked = false;
          opt.closest('.option').classList.remove('selected');
        });

        // Set the selected option
        quizState.answers[questionId] = value;
        this.classList.add('selected');
        input.checked = true;
      }
    });
  });
}

function renderResults(container) {
  var html = '\n    <div class="quiz-results">\n      ' + (!quizState.formSubmitted ? '\n        <h3>Almost Done!</h3>\n        <p>Fill out the form below to receive your personalized assessment.</p>\n        <div id="hubspot-form-container" class="hbspt-form"></div>\n      ' : '\n        <h3>Thank You!</h3>\n        <p>Your score reflects how effectively your state\'s early childhood data systems support decision-making, funding transparency, and child care access.</p>\n        ' + function () {
    var recommendation = getRecommendation();

    return '\n            <div class="recommendation">\n              <h4>' + recommendation.title + '</h4>\n              <p>' + recommendation.range + '</p>\n              <p>' + recommendation.description + '</p>\n              <p class=\'space-above\'><strong>Where to focus next:</strong></p>\n              <ul>\n                ' + recommendation.focusAreas.map(function (area) {
      return '<li>' + area + '</li>';
    }).join('') + '\n              </ul>\n              <p class=\'space-above\'>Our team will be in touch to help you reach your state\'s potential.</p>\n            </div>\n          ';
  }() + '\n      ') + '\n    </div>\n  ';

  container.innerHTML = html;

  if (!quizState.formSubmitted) {
    // Create HubSpot form
    hbspt.forms.create({
      portalId: '7120550',
      formId: '44fd8562-04d5-4258-b1cb-97a1731874bd',
      region: 'na1',
      target: '#hubspot-form-container',
      onFormReady: function onFormReady($form) {
        var recommendation = getRecommendation();
        var surveyResultField = $form.find('input[name="early_childhood_survey_result"]');
        if (surveyResultField.length) {
          surveyResultField.val(recommendation.title);
        }

        var surveyInfoField = $form.find('input[name="early_childhood_survey_info"]');
        if (surveyInfoField.length) {
          surveyInfoField.val(formatSurveyAnswers());
        }
      },
      onFormSubmitted: function onFormSubmitted() {
        quizState.formSubmitted = true;
        updateQuizDisplay();
      }
    });
  }
}

function showResults() {
  quizState.showResults = true;
  updateQuizDisplay();
}

function scoreFromAnswer(questionId, answerText) {
  var question = questions.find(function (q) {
    return q.id === questionId;
  });
  if (!question) {
    return 0;
  }
  if (!answerText || typeof answerText !== 'string') {
    return 0;
  }
  var selectedIndex = question.options.indexOf(answerText);
  if (selectedIndex === -1) {
    return 0;
  }
  if (!Array.isArray(question.points) || question.points[selectedIndex] === undefined) {
    return 0;
  }
  return question.points[selectedIndex];
}

function getTotalScore() {
  var total = 0;
  questions.forEach(function (q) {
    total += scoreFromAnswer(q.id, quizState.answers[q.id]);
  });
  return total;
}

function getReadinessPercent() {
  var total = getTotalScore();
  return total / 24 * 100;
}

function formatSurveyAnswers() {
  var answers = [];

  answers.push('Early Childhood Data Maturity Assessment');

  // Add intro question answer
  answers.push(introQuestion.id + ': ' + (quizState.introAnswer || 'Not provided'));

  // Add scored questions
  questions.forEach(function (q) {
    answers.push(q.id + ': ' + (quizState.answers[q.id] || 'Not provided'));
  });

  // Sanitize the final string for safe use in input value
  var joinedAnswers = answers.join('\n');
  var div = document.createElement('div');
  div.textContent = joinedAnswers;
  return div.innerHTML;
}

function getRecommendation() {
  var percent = getReadinessPercent();

  if (percent <= 33) {
    return {
      title: 'The Silo Specialist',
      range: 'Score range: 0-33%',
      description: 'Your systems likely operate independently across programs such as subsidy, Pre-K, licensing, and workforce registries. Key insights require manual effort, and it may be difficult to see a complete picture of children, providers, and funding.',
      focusAreas: ['Establish clear data governance and sharing agreements', 'Identify -2 high-impact system connections to prioritize', 'Reduce reliance on manual reporting for core metrics']
    };
  }

  if (percent <= 67) {
    return {
      title: 'The Emerging Integrator',
      range: 'Score range: 34-66%',
      description: 'Your state has started connecting systems and using data to support oversight. Some insights are available, but many processes still rely on manual analysis or partial integration.',
      focusAreas: ['Expand automated data integrations across programs', 'Standardize key data definitions across agencies', 'Build dashboards for supply, workforce, and funding visibility']
    };
  }

  return {
    title: 'The Data Luminary',
    range: 'Score range: 67-100%',
    description: 'Your state is using connected data to guide policy and program performance. Leaders likely have access to dashboards and cross-program insights that support planning and accountability.',
    focusAreas: ['Strengthen predictive analytics and forecasting capabilities', 'Expand real-time data access to more stakeholders', 'Document and share best practices with other states']
  };
}

// Initialize quiz when DOM is loaded
jQuery(document).ready(function ($) {
  var quizContent = document.querySelector('.quiz-content-childhood');
  if (!quizContent) {
    return;
  }

  var container = quizContent.querySelector('.quiz-container-childhood');
  if (!container) {
    return;
  }

  // Make functions globally available (only when childhood quiz exists)
  window.prevStep = function () {
    if (quizState.currentStep > -1) {
      quizState.currentStep--;
      updateQuizDisplay();
      updateProgressBar();
    }
  };

  window.nextStep = function () {
    if (quizState.currentStep < questions.length - 1) {
      quizState.currentStep++;
      updateQuizDisplay();
      updateProgressBar();
    } else {
      quizState.showResults = true;
      updateQuizDisplay();
    }
  };

  updateQuizDisplay();
  updateProgressBar();

  // Check for #start-quiz hash in URL to scroll to quiz section if present
  if (window.location.hash === '#start-quiz') {
    // Scroll to the quiz section
    setTimeout(function () {
      $('html, body').animate({
        scrollTop: $('.section-quiz').offset().top - 100
      }, 500);
    }, 500); // Small delay to ensure everything is loaded properly
  }
});

},{}],39:[function(require,module,exports){
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Quiz configuration and state management
var quizState = {
  currentStep: -1, // Start with intro page
  answers: {},
  contactInfo: {
    name: '',
    company: '',
    email: '',
    phone: '',
    role: '',
    companySize: '',
    industrySubsector: '',
    dataSystems: ''
  },
  showResults: false,
  formSubmitted: false
};

// Make functions globally available
window.prevStep = function () {
  if (quizState.currentStep > -1) {
    quizState.currentStep--;
    updateQuizDisplay();
    updateProgressBar();
  }
};

window.nextStep = function () {
  if (quizState.currentStep < questions.length - 1) {
    quizState.currentStep++;
    updateQuizDisplay();
    updateProgressBar();
  } else {
    quizState.showResults = true;
    updateQuizDisplay();
  }
};

// Quiz questions configuration
var questions = [{
  id: "fleet_size",
  text: "What is the total size of your fleet?",
  options: ["1-50 vehicles", "51-200 vehicles", "201-500 vehicles", "501-1500 vehicles", "1500+ vehicles", "N/A - Not directly managing fleet"]
}, {
  id: "data_sources",
  text: "Which data sources currently exist within your fleet operations?",
  type: "multiselect",
  options: ["Telematics/GPS tracking data", "Fuel transaction data", "Maintenance records", "Driver behavior/safety data", "Vehicle acquisition/lifecycle data", "ERP/financial systems data", "None of the above"]
}, {
  id: "data_integration",
  text: "How would you describe your current fleet data integration status?",
  options: ["Fully integrated - comprehensive data warehouse/lake", "Partially integrated - some systems connected", "Minimal integration - mostly manual data transfers", "No integration - separate systems with manual reporting", "Unsure - we need help assessing our current state"]
}, {
  id: "data_access",
  text: "How does your organization currently access fleet insights?",
  options: ["Self-service dashboards with real-time data", "Scheduled standard reports", "Custom reports built on request", "Spreadsheets with manually compiled data", "Limited visibility into comprehensive fleet data"]
}, {
  id: "primary_challenge",
  text: "What are your primary fleet data challenges?",
  type: "multiselect",
  options: ["Integrating data from multiple systems", "Limited visibility into total cost of ownership", "Difficulty predicting maintenance needs", "Lack of actionable insights from data", "Poor data quality/inconsistency", "Limited reporting capabilities", "No single source of truth", "Inability to make data-driven decisions"]
}, {
  id: "analytics_interest",
  text: "Which analytics capabilities would be most valuable for your organization?",
  type: "multiselect",
  options: ["Total cost of ownership modeling", "Predictive maintenance analytics", "Driver behavior/safety analysis", "Route and utilization optimization", "Real-time fleet performance dashboards", "Automated cross-system reporting", "Maintenance cost forecasting", "Data-driven replacement planning"]
}, {
  id: "ev_challenges",
  text: "What EV transition data challenges are you facing?",
  type: "multiselect",
  options: ["Insufficient cost data from current vehicles", "Inability to model EV vs. ICE costs accurately", "Lack of data for infrastructure planning", "Poor vehicle utilization visibility", "Not currently planning EV transition", "N/A - Already have robust EV data strategy"]
}, {
  id: "time_frame",
  text: "What is your timeframe for improving your fleet data capabilities?",
  options: ["Immediate (0-3 months)", "Short-term (3-6 months)", "Medium-term (6-12 months)", "Long-term planning (12+ months)", "No specific timeframe"]
}];

// Function to update progress bar
function updateProgressBar() {
  var totalSteps = questions.length;
  var currentStep = quizState.currentStep + 1; // Add 1 because currentStep is 0-indexed
  var progressPercent = quizState.currentStep >= 0 ? currentStep / totalSteps * 100 : 0;

  var progressBar = document.querySelector('.progress-bar');
  if (progressBar) {
    // Hide progress bar if progress is 0%
    if (progressPercent === 0) {
      progressBar.style.opacity = '0';
      progressBar.style.visibility = 'hidden';
    } else {
      progressBar.style.opacity = '1';
      progressBar.style.visibility = 'visible';
    }

    var progress = progressBar.querySelector('.progress');
    if (progress) {
      progress.style.width = progressPercent + '%';
    }

    // Add or update percentage display
    var percentDisplay = progressBar.querySelector('.percent-display');
    if (!percentDisplay) {
      percentDisplay = document.createElement('div');
      percentDisplay.className = 'percent-display';
      progressBar.appendChild(percentDisplay);
    }

    // Update the percentage text
    percentDisplay.textContent = Math.round(progressPercent) + '%';
  }
}

// Quiz functionality
function handleAnswer(questionId, value, isMultiselect) {
  if (isMultiselect) {
    // Initialize as array if not exists
    if (!Array.isArray(quizState.answers[questionId])) {
      quizState.answers[questionId] = [];
    }

    var index = quizState.answers[questionId].indexOf(value);
    if (index === -1) {
      // Add value if not present
      quizState.answers[questionId].push(value);
    } else {
      // Remove value if present
      quizState.answers[questionId].splice(index, 1);
    }
  } else {
    quizState.answers[questionId] = value;
  }

  updateQuizDisplay();
  updateProgressBar();
}

function handleNext() {
  // Special case for intro page
  if (quizState.currentStep === -1) {
    quizState.currentStep++;
    updateQuizDisplay();
    updateProgressBar();
    return;
  }

  var currentQuestion = questions[quizState.currentStep];
  var currentAnswer = quizState.answers[currentQuestion.id];

  if (!currentAnswer || Array.isArray(currentAnswer) && currentAnswer.length === 0) {
    alert("Please select at least one option before continuing.");
    return;
  }

  if (quizState.currentStep < questions.length - 1) {
    quizState.currentStep++;
    updateQuizDisplay();
    updateProgressBar();
  } else {
    showResults();
  }
}

function handlePrevious() {
  if (quizState.currentStep > -1) {
    quizState.currentStep--;
    updateQuizDisplay();
    updateProgressBar();
  }
}

function handleInputChange(event) {
  var _event$target = event.target,
      name = _event$target.name,
      value = _event$target.value;

  quizState.contactInfo[name] = value;
}

function isOptionSelected(questionId, optionValue) {
  var answer = quizState.answers[questionId];
  if (!answer) return false;

  if (Array.isArray(answer)) {
    // For multiselect questions (checkboxes)
    return answer.includes(optionValue);
  } else {
    // For single select questions (radio buttons)
    return answer === optionValue;
  }
}

function updateQuizDisplay() {
  var quizContent = document.querySelector('.quiz-content-fleet');
  if (!quizContent) return;

  // Clear any existing selected classes
  var existingOptions = quizContent.querySelectorAll('.option');
  existingOptions.forEach(function (option) {
    return option.classList.remove('selected');
  });

  if (quizState.showResults) {
    renderResults(quizContent);
    return;
  }

  var container = quizContent.querySelector('.quiz-container-fleet');

  // Update progress bar
  updateProgressBar();

  // Special case for intro page (currentStep = -1)
  if (quizState.currentStep === -1) {
    // Get the first question to display alongside intro
    var firstQuestion = questions[0];
    var firstQuestionOptionsHtml = '';

    firstQuestion.options.forEach(function (option, index) {
      var isChecked = isOptionSelected(firstQuestion.id, option) ? 'checked' : '';
      var isSelected = isOptionSelected(firstQuestion.id, option) ? 'selected' : '';

      firstQuestionOptionsHtml += '\n        <div class="option ' + isSelected + '">\n          <input type="' + (firstQuestion.type === 'multiselect' ? 'checkbox' : 'radio') + '"\n                 name="' + firstQuestion.id + '"\n                 value="' + option + '"\n                 id="' + firstQuestion.id + '_' + index + '"\n                 ' + isChecked + '>\n          <label for="' + firstQuestion.id + '_' + index + '">' + option + '</label>\n        </div>\n      ';
    });

    container.innerHTML = '\n      <div class="quiz-step quiz-intro">\n        <div class="intro-container">\n          <div class="intro-content">\n            <p>This free, five-minute assessment from Resultant\'s fleet optimization and data experts is based on decades of consulting experience. It will help you start to understand how well your organization is using fleet data to inform operational decisions.</p>\n            <p>Once complete, you\'ll receive a personalized recommendation for your top optimization focus area, plus suggested next steps to take things to the next level.</p>\n            <p>Your responses are confidential and never shared publicly.</p>\n          </div>\n          <div class="first-question">\n            <div class="quiz-question">\n              <h3>' + firstQuestion.text + '</h3>\n              <div class="options">\n                ' + firstQuestionOptionsHtml + '\n              </div>\n            </div>\n            <div class="navigation intro-nav">\n              <button type="button" class="next-btn">Next</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    ';

    // Add event listeners for the first question options
    addOptionEventListeners(container.querySelectorAll('.first-question .option'));

    // Add event listener for the Next button
    container.querySelector('.next-btn').addEventListener('click', function () {
      var currentQuestion = questions[0];
      var currentAnswer = quizState.answers[currentQuestion.id];

      if (!currentAnswer || Array.isArray(currentAnswer) && currentAnswer.length === 0) {
        alert("Please select at least one option before continuing.");
        return;
      }

      quizState.currentStep = 1; // Skip to second question since we've already shown the first
      updateQuizDisplay();
    });

    return;
  }

  var question = questions[quizState.currentStep];

  // Check if question is defined before proceeding
  if (!question) {
    console.error('Question is undefined for step:', quizState.currentStep);
    return;
  }

  var savedAnswer = quizState.answers[question.id];

  var optionsHtml = '';
  question.options.forEach(function (option, index) {
    var isChecked = '';
    var isSelected = '';

    if (question.type === 'multiselect') {
      // For multiselect, savedAnswer is an array
      var savedAnswers = Array.isArray(savedAnswer) ? savedAnswer : [];
      isChecked = savedAnswers.includes(option) ? 'checked' : '';
      isSelected = savedAnswers.includes(option) ? 'selected' : '';
    } else {
      // For single select
      isChecked = savedAnswer === option ? 'checked' : '';
      isSelected = savedAnswer === option ? 'selected' : '';
    }

    optionsHtml += '\n      <div class="option ' + isSelected + '">\n        <input type="' + (question.type === 'multiselect' ? 'checkbox' : 'radio') + '"\n               name="' + question.id + '"\n               value="' + option + '"\n               id="' + question.id + '_' + index + '"\n               ' + isChecked + '>\n        <label for="' + question.id + '_' + index + '">' + option + '</label>\n      </div>\n    ';
  });

  container.innerHTML = '\n    <div class="quiz-step">\n      <div class="quiz-question">\n        <h3>' + question.text + '</h3>\n        <div class="options">\n          ' + optionsHtml + '\n        </div>\n      </div>\n      <div class="navigation">\n        ' + (quizState.currentStep > 0 ? '<button type="button" class="prev-btn">Previous</button>' : '') + '\n        <button type="button" class="next-btn">\n          ' + (quizState.currentStep === questions.length - 1 ? 'Submit' : 'Next') + '\n        </button>\n      </div>\n    </div>\n  ';

  // Add event listeners
  container.querySelector('.next-btn').addEventListener('click', handleNext);
  if (quizState.currentStep > 0) {
    container.querySelector('.prev-btn').addEventListener('click', handlePrevious);
  }

  var options = container.querySelectorAll('.option');
  options.forEach(function (option) {
    var input = option.querySelector('input');

    // Only handle clicks on the option div itself
    option.addEventListener('click', function (event) {
      // Prevent handling if the click was on the input or label
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'LABEL') {
        return;
      }

      if (input) {
        var isMultiselect = input.type === 'checkbox';
        // console.log('Option clicked:', {
        //   isMultiselect,
        //   beforeChecked: input.checked,
        //   target: event.target.tagName
        // });

        // Manually toggle the checkbox state
        if (isMultiselect) {
          input.checked = !input.checked;
          // Dispatch change event manually
          input.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });

    // Handle input changes
    input.addEventListener('change', function (event) {
      var questionId = input.getAttribute('name');
      var isMultiselect = input.type === 'checkbox';

      // console.log('Input changed:', {
      //   isMultiselect,
      //   checked: input.checked,
      //   value: input.value
      // });

      // Update visual state
      if (isMultiselect) {
        option.classList.toggle('selected', input.checked);
      } else {
        var allOptions = option.closest('.options').querySelectorAll('.option');
        allOptions.forEach(function (opt) {
          return opt.classList.remove('selected');
        });
        option.classList.add('selected');
      }

      // Update quiz state
      handleAnswer(questionId, input.value, isMultiselect);
    });
  });
}

function addOptionEventListeners(options) {
  options.forEach(function (option) {
    option.addEventListener('click', function () {
      var input = this.querySelector('input');
      var questionId = input.name;
      var value = input.value;
      var isMultiselect = input.type === 'checkbox';

      // Handle intro content fade out if this is the first question
      if (quizState.currentStep === -1) {
        var introContent = document.querySelector('.intro-content');
        var firstQuestion = document.querySelector('.first-question');

        if (introContent && firstQuestion) {
          // Add hide-intro class to fade out the intro content
          introContent.classList.add('hide-intro');

          // Make the first question take full width
          firstQuestion.classList.add('full-width');
        }
      }

      if (isMultiselect) {
        // For multiselect, toggle the selection
        if (!quizState.answers[questionId]) {
          quizState.answers[questionId] = [];
        }

        var index = quizState.answers[questionId].indexOf(value);
        if (index === -1) {
          quizState.answers[questionId].push(value);
          this.classList.add('selected');
          input.checked = true;
        } else {
          quizState.answers[questionId].splice(index, 1);
          this.classList.remove('selected');
          input.checked = false;
        }
      } else {
        // For single select, clear other selections
        var allOptions = document.querySelectorAll('input[name="' + questionId + '"]');
        allOptions.forEach(function (opt) {
          opt.checked = false;
          opt.closest('.option').classList.remove('selected');
        });

        // Set the selected option
        quizState.answers[questionId] = value;
        this.classList.add('selected');
        input.checked = true;
      }
    });
  });
}

function renderResults(container) {
  var html = '\n    <div class="quiz-results">\n      ' + (!quizState.formSubmitted ? '\n        <h3>Almost Done!</h3>\n        <p>Fill out the form below to receive your personalized assessment.</p>\n        <div id="hubspot-form-container" class="hbspt-form"></div>\n      ' : '\n        <h3>Thank You!</h3>\n        <p>Based on your answers, here are our recommendations:</p>\n        ' + function () {
    var recommendation = getRecommendation();

    return '\n            <div class="recommendation">\n              <h4>' + recommendation.title + '</h4>\n              <p>' + recommendation.description + '</p>\n              <a href="' + recommendation.ctaLink + '" class="btn btn-secondary" target="_blank">' + recommendation.cta + '</a>\n            </div>\n          ';
  }() + '\n      ') + '\n    </div>\n  ';

  container.innerHTML = html;

  if (!quizState.formSubmitted) {
    // Create HubSpot form
    hbspt.forms.create({
      portalId: "7120550",
      formId: "6cb66aba-11f9-4271-847c-04b39a956340",
      region: "na1",
      target: "#hubspot-form-container",
      onFormReady: function onFormReady($form) {
        var recommendation = getRecommendation();
        //console.log('Setting surveyResultField value: ', recommendation.title);
        var surveyResultField = $form.find('input[name="transportation_survey_result"]');
        //console.log('surveyResultField: ', surveyResultField);
        if (surveyResultField.length) {
          surveyResultField.val(recommendation.title);
        }

        //console.log('Setting surveyInfoField value: ', formatSurveyAnswers());
        var surveyInfoField = $form.find('input[name="transportation_survey_info"]');
        //console.log('surveyInfoField: ', surveyInfoField);
        if (surveyInfoField.length) {
          surveyInfoField.val(formatSurveyAnswers());
        }
      },
      onFormSubmitted: function onFormSubmitted() {
        quizState.formSubmitted = true;
        updateQuizDisplay();
      }
    });
  }
}

function showResults() {
  quizState.showResults = true;
  updateQuizDisplay();
}

function formatSurveyAnswers() {
  var answers = [];

  // Format fleet size
  answers.push('Fleet Size: ' + (quizState.answers.fleet_size || 'Not provided'));

  // Format data sources
  var dataSources = quizState.answers.data_sources || [];
  answers.push('Data Sources: ' + (dataSources.join(', ') || 'None selected'));

  // Format data integration
  answers.push('Data Integration Status: ' + (quizState.answers.data_integration || 'Not provided'));

  // Format data access
  answers.push('Data Access Method: ' + (quizState.answers.data_access || 'Not provided'));

  // Format primary challenges
  var challenges = quizState.answers.primary_challenge || [];
  answers.push('Primary Challenges: ' + (challenges.join(', ') || 'None selected'));

  // Format analytics interest
  var analytics = quizState.answers.analytics_interest || [];
  answers.push('Analytics Interests: ' + (analytics.join(', ') || 'None selected'));

  // Format EV challenges
  var evChallenges = quizState.answers.ev_challenges || [];
  answers.push('EV Challenges: ' + (evChallenges.join(', ') || 'None selected'));

  // Format timeframe
  answers.push('Timeframe: ' + (quizState.answers.time_frame || 'Not provided'));

  // Sanitize the final string for safe use in input value
  var joinedAnswers = answers.join('\n');
  var div = document.createElement('div');
  div.textContent = joinedAnswers;
  return div.innerHTML;
}

function getRecommendation() {
  var fleetSize = quizState.answers.fleet_size;
  var dataSources = quizState.answers.data_sources || [];
  var dataIntegration = quizState.answers.data_integration;
  var dataAccess = quizState.answers.data_access;
  var primaryChallenges = quizState.answers.primary_challenge || [];
  var analyticsInterest = quizState.answers.analytics_interest || [];
  var evChallenges = quizState.answers.ev_challenges || [];
  var timeFrame = quizState.answers.time_frame;

  // Score different recommendation paths based on answers
  var scores = {
    dataIntegration: 0,
    analytics: 0,
    visualization: 0,
    predictiveMaintenance: 0,
    evStrategy: 0,
    dataArchitecture: 0,
    dataMaturityGuide: 0
  };

  // Data integration scoring
  if (dataIntegration === "No integration - separate systems with manual reporting") {
    scores.dataIntegration += 5;
  } else if (dataIntegration === "Minimal integration - mostly manual data transfers") {
    scores.dataIntegration += 4;
  } else if (dataIntegration === "Partially integrated - some systems connected") {
    scores.dataIntegration += 2;
  }
  if (dataSources.length >= 3) {
    scores.dataIntegration += 2;
  }
  if (primaryChallenges.includes("Integrating data from multiple systems")) {
    scores.dataIntegration += 3;
  }
  if (primaryChallenges.includes("No single source of truth")) {
    scores.dataIntegration += 3;
  }

  // Analytics scoring
  if (primaryChallenges.includes("Limited visibility into total cost of ownership")) {
    scores.analytics += 3;
  }
  if (primaryChallenges.includes("Lack of actionable insights from data")) {
    scores.analytics += 3;
  }
  if (analyticsInterest.includes("Total cost of ownership modeling") || analyticsInterest.includes("Fleet rightsizing analysis")) {
    scores.analytics += 2;
  }

  // Visualization scoring
  if (dataAccess === "Spreadsheets with manually compiled data") {
    scores.visualization += 4;
  } else if (dataAccess === "Limited visibility into comprehensive fleet data") {
    scores.visualization += 3;
  } else if (dataAccess === "Custom reports built on request") {
    scores.visualization += 2;
  }
  if (primaryChallenges.includes("Limited reporting capabilities")) {
    scores.visualization += 3;
  }
  if (analyticsInterest.includes("Real-time fleet performance dashboards") || analyticsInterest.includes("Automated cross-system reporting")) {
    scores.visualization += 2;
  }

  // Predictive maintenance scoring
  if (primaryChallenges.includes("Difficulty predicting maintenance needs")) {
    scores.predictiveMaintenance += 4;
  }
  if (analyticsInterest.includes("Predictive maintenance analytics") || analyticsInterest.includes("Maintenance cost forecasting")) {
    scores.predictiveMaintenance += 3;
  }
  if (dataSources.includes("Maintenance records") && dataSources.includes("Telematics/GPS tracking data")) {
    scores.predictiveMaintenance += 2;
  }

  // EV strategy scoring
  if (evChallenges.includes("Insufficient cost data from current vehicles")) {
    scores.evStrategy += 3;
  }
  if (evChallenges.includes("Inability to model EV vs. ICE costs accurately")) {
    scores.evStrategy += 3;
  }
  if (evChallenges.includes("Lack of data for infrastructure planning") || evChallenges.includes("Poor vehicle utilization visibility")) {
    scores.evStrategy += 2;
  }

  // Data architecture scoring
  if (fleetSize === "501-1500 vehicles" || fleetSize === "1500+ vehicles") {
    scores.dataArchitecture += 2;
  }
  if (dataIntegration === "Fully integrated - comprehensive data warehouse/lake" && (primaryChallenges.includes("Poor data quality/inconsistency") || primaryChallenges.includes("Inability to make data-driven decisions"))) {
    scores.dataArchitecture += 3;
  }
  if (timeFrame === "Medium-term (6-12 months)" || timeFrame === "Long-term planning (12+ months)") {
    scores.dataArchitecture += 1;
  }

  // Data Maturity Guide scoring
  if (timeFrame === "Long-term planning (12+ months)" || timeFrame === "No specific timeframe") {
    scores.dataMaturityGuide += 2;
  }
  if (dataIntegration === "Unsure - we need help assessing our current state") {
    scores.dataMaturityGuide += 3;
  }
  if (primaryChallenges.length >= 4) {
    scores.dataMaturityGuide += 1;
  }
  if (fleetSize === "1-50 vehicles" && dataAccess !== "Self-service dashboards with real-time data") {
    scores.dataMaturityGuide += 1;
  }

  // Determine the highest score
  var highestScore = 0;
  var recommendationType = 'dataArchitecture';
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Object.entries(scores)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref = _step.value;

      var _ref2 = _slicedToArray(_ref, 2);

      var type = _ref2[0];
      var score = _ref2[1];

      if (score > highestScore) {
        highestScore = score;
        recommendationType = type;
      }
    }

    // Custom handling for special cases
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var topScores = Object.entries(scores).sort(function (a, b) {
    return b[1] - a[1];
  });
  if (topScores[0][1] - topScores[1][1] <= 1) {
    if (timeFrame === "Immediate (0-3 months)" || timeFrame === "Short-term (3-6 months)") {
      if (topScores[0][0] === "dataArchitecture" && (topScores[1][0] === "visualization" || topScores[1][0] === "dataIntegration")) {
        recommendationType = topScores[1][0];
      }
    }
  }

  // Return the appropriate recommendation
  switch (recommendationType) {
    case 'dataIntegration':
      return {
        title: "Fleet Data Integration Assessment",
        description: "You're at the starting line—and data integration is step one. Begin by understanding what's in place with a comprehensive review of your current systems so you can move forward with confidence. This evaluation should include mapping data sources, identifying integration challenges, and outlining a practical roadmap for a unified platform.<br><br>Connect with our transportation data experts for a free, 30-minute discovery session. We'll discuss your current integration challenges and determine if a more comprehensive Design Thinking workshop would help map your path forward. This conversation is your first step toward solving integration challenges with clarity and direction.",
        cta: "Schedule Your Discovery Call",
        ctaLink: "https://meetings.hubspot.com/carl-lowgren"
      };
    case 'analytics':
      return {
        title: "Fleet Analytics and Business Intelligence Assessment",
        description: "You've got data — but is it working for you? Your results suggest it's time for a closer look to determine if your fleet analytics and strategy truly transform raw data into <a href='https://resultant.com/blog/data-analytics/turning-data-into-a-competitive-edge-in-fleet-management/' target='_blank'>insights you can act upon</a>. Evaluate your key metrics and reporting tools, then make a plan to build dashboards that reflect what matters most to your operations.<br><br>Connect with our transportation data experts for a free, 30-minute discovery session. We'll explore your current analytics capabilities and challenges and determine if a focused Design Thinking workshop could better align your data strategy with business outcomes. This conversation is the first step toward building a roadmap for your fleet intelligence transformation.",
        cta: "Book Your Analytics Discovery Session",
        ctaLink: "https://meetings.hubspot.com/carl-lowgren"
      };
    case 'visualization':
      return {
        title: "Fleet Data Visualization Solutions",
        description: "Your results show it's time to turn your fleet data into real-time decisions by leveling up visibility. With interactive dashboards and automated reporting, you can give your team real-time access to performance data—fueling <a href='https://resultant.com/blog/data-analytics/fleet-failures-are-optional-the-data-driven-approach-to-staying-ahead/' target='_blank'>smarter decisions</a> and better outcomes at every level.<br><br>Connect with our transportation data experts for a free, 30-minute exploratory session. We'll dig into your visualization needs and demonstrate possible visualizations for fleets like yours. You'll have the option to arrange a subsequent in-depth Design Thinking workshop that fully explores your requirements and visualization opportunities.",
        cta: "Explore Your Visualization Options",
        ctaLink: "https://meetings.hubspot.com/carl-lowgren"
      };
    case 'predictiveMaintenance':
      return {
        title: "Predictive Maintenance Analytics",
        description: "Your results show it's time to move maintenance operations from reactive to proactive through predictive analytics. Step one: check the health of your maintenance data. Then, pinpoint where forecasting tools could help prevent costly failures—and build a rollout plan that fits your fleet.<br><br>Connect with our transportation data experts for a free, 30-minute introductory session. We'll learn about your maintenance challenges and share how predictive approaches have helped similar organizations. For those ready to go deeper, we can schedule a collaborative Design Thinking workshop to develop your customized predictive maintenance framework.",
        cta: "Start Your Predictive Maintenance Conversation",
        ctaLink: "https://meetings.hubspot.com/carl-lowgren"
      };
    case 'evStrategy':
      return {
        title: "EV Transition Data Strategy",
        description: "Your results show it's time for a plan to navigate the complex data challenges of electric vehicle adoption. You'll benefit from establishing baseline metrics for your current fleet, modeling TCO comparisons between combustion and electric vehicles, and developing a <a href='https://resultant.com/insights/client-stories/global-transportation-leader-boosts-roi-with-fleet-management-system-reinvention/' target='_blank'>data framework for infrastructure</a> planning.<br><br>Connect with our transportation data experts for a free, 30-minute discussion about your EV transition challenges. We'll identify your key concerns and determine if a facilitated Design Thinking session is a good next step for developing a comprehensive data strategy targeted to this complex transition.",
        cta: "Discuss Your EV Transition Challenges",
        ctaLink: "https://meetings.hubspot.com/carl-lowgren"
      };
    case 'dataArchitecture':
      return {
        title: "Custom Fleet Data Strategy",
        description: "Your results show you're ready for a <a href='https://resultant.com/insights/client-stories/global-transportation-leader-boosts-roi-with-fleet-management-system-reinvention/' target='_blank'>tailored fleet data strategy</a>. Start by evaluating your current transportation data ecosystem, including system architecture, integration methods, and how well they align with your business goals. A custom strategy—complete with a phased rollout plan—will give you the clarity and structure to move forward with confidence.<br><br>Connect with our transportation data experts for a free, 30-minute strategic discussion. In this conversation, we'll align your data landscape with your business goals—and help determine if a Design Thinking workshop is the right next move. Together, we'll assess your data ecosystem and how well it matches your business priorities, then determine if a Design Thinking workshop can accelerate your strategy. This initial conversation kickstarts the process of aligning your data strategy with measurable business impact.",
        cta: "Begin Your Data Strategy Discussion",
        ctaLink: "https://meetings.hubspot.com/carl-lowgren"
      };
    case 'dataMaturityGuide':
      return {
        title: "Fleet Data Maturity Assessment",
        description: "Your results show that a data maturity assessment would benefit your company, giving you competitive insights and benchmarking where your fleet data capabilities currently stand compared to others in the industry. A practical maturity model helps you take the guesswork out of growth—defining where to focus and how to advance across all five areas of <a href='https://resultant.com/blog/data-analytics/turning-data-into-a-competitive-edge-in-fleet-management/' target='_blank'>fleet data management</a>.<br><br>Connect with our transportation data experts for a free, 30-minute discovery call. We'll assess where you are, uncover roadblocks, and determine if a Design Thinking workshop can fast-track your analytics maturity.",
        cta: "Evaluate Your Fleet Data Readiness",
        ctaLink: "https://meetings.hubspot.com/carl-lowgren"
      };
    default:
      return {
        title: "Custom Fleet Data Strategy",
        description: "Your results show you're ready for a tailored fleet data strategy. Start by evaluating your current transportation data ecosystem, including system architecture, integration methods, and how well they align with your business goals. A custom strategy—complete with a phased rollout plan—will give you the clarity and structure to move forward with confidence.<br><br>Connect with our transportation data experts for a free, 30-minute strategic discussion. In this conversation, we'll align your data landscape with your business goals—and help determine if a Design Thinking workshop is the right next move. Together, we'll assess your data ecosystem and how well it matches your business priorities, then determine if a Design Thinking workshop can accelerate your strategy. This initial conversation kickstarts the process of aligning your data strategy with measurable business impact.",
        cta: "Begin Your Data Strategy Discussion",
        ctaLink: "https://meetings.hubspot.com/carl-lowgren"
      };
  }
}

// Initialize quiz when DOM is loaded
jQuery(document).ready(function ($) {
  var quizContent = document.querySelector('.quiz-content-fleet');
  if (!quizContent) {
    return;
  }

  var container = quizContent.querySelector('.quiz-container-fleet');
  if (!container) {
    return;
  }

  updateQuizDisplay();
  updateProgressBar();

  // Check for #start-quiz hash in URL to scroll to quiz section if present
  if (window.location.hash === '#start-quiz') {
    // Scroll to the quiz section
    setTimeout(function () {
      $('html, body').animate({
        scrollTop: $('.section-quiz').offset().top - 100
      }, 500);
    }, 500); // Small delay to ensure everything is loaded properly
  }
});

},{}],40:[function(require,module,exports){
'use strict';

// Quiz configuration and state management
var quizState = {
  currentStep: -1, // Start with intro page
  answers: {},
  contactInfo: {
    name: '',
    company: '',
    email: '',
    phone: '',
    role: '',
    companySize: '',
    industrySubsector: '',
    dataSystems: ''
  },
  showResults: false,
  formSubmitted: false
};

// Quiz questions configuration
var questions = [{
  id: 'system_connectivity',
  headline: 'Pillar 1: Data Integration',
  text: 'How well are your core systems (SIS, assessment, finance, HR, etc.) integrated today?',
  options: ['Systems are fully integrated with automated data flows and minimal manual effort', 'Most key systems are connected, with some manual processes', 'Limited integrations; frequent manual data pulls required', 'Systems operate mostly in silos', 'No integration or not sure'],
  points: [4, 3, 2, 1, 0]
}, {
  id: 'data_consistency_governance',
  headline: 'Pillar 1: Data Integration',
  text: 'How consistent are definitions and metrics across your district?',
  options: ['Standardized definitions and metrics are enforced district-wide', 'Mostly consistent, with minor variations', 'Definitions exist but are inconsistently applied', 'Definitions vary significantly across teams or schools', 'No standard definitions or not sure'],
  points: [4, 3, 2, 1, 0]
}, {
  id: 'visibility_for_leadership',
  headline: 'Pillar 2: Decision Enablement',
  text: 'How easily can district leadership access a real-time, complete view of performance?',
  options: ['Real-time dashboards provide a clear, trusted, district-wide view', 'Dashboards exist but require validation or manual updates', 'Reports are available but lag behind real conditions', 'Limited visibility beyond static reports or spreadsheets', 'No reliable visibility or not sure'],
  points: [4, 3, 2, 1, 0]
}, {
  id: 'school_staff_access',
  headline: 'Pillar 2: Decision Enablement',
  text: 'How well are principals and staff equipped to act on data?',
  options: ['Schools have timely, actionable insights embedded into workflows', 'Data is accessible but not always easy to act on', 'Staff must manually gather and interpret data', 'Limited access to meaningful insights', 'No consistent access or not sure'],
  points: [4, 3, 2, 1, 0]
}, {
  id: 'program_effectiveness',
  headline: 'Pillar 3: Outcomes and Accountability',
  text: 'How well can you evaluate which programs or interventions are working?',
  options: ['Outcomes are clearly defined, tracked, and tied to decisions', 'Metrics exist but are not consistently used', 'Evaluation is limited or inconsistent', 'Minimal ability to assess effectiveness', 'Not currently possible or not sure'],
  points: [4, 3, 2, 1, 0]
}, {
  id: 'communicating_outcomes',
  headline: 'Pillar 3: Outcomes and Accountability',
  text: 'How effectively can you communicate results to leadership, boards, and stakeholders using dashboards?',
  options: ['Clear, trusted dashboards and outcome metrics regularly inform decisions', 'Reporting exists but lacks consistency or clarity', 'Reporting focuses mainly on compliance or basic metrics', 'Limited ability to communicate impact beyond static reports', 'No established approach or not sure'],
  points: [4, 3, 2, 1, 0]
}];

// Function to update progress bar
function updateProgressBar() {
  var totalSteps = questions.length;
  var currentStep = quizState.currentStep > 0 ? quizState.currentStep : 0;
  var progressPercent = quizState.currentStep > 0 ? currentStep / totalSteps * 100 : 0;

  var progressBar = document.querySelector('.progress-bar');
  if (progressBar) {
    // Hide progress bar if progress is 0%
    if (progressPercent === 0) {
      progressBar.style.opacity = '0';
      progressBar.style.visibility = 'hidden';
    } else {
      progressBar.style.opacity = '1';
      progressBar.style.visibility = 'visible';
    }

    var progress = progressBar.querySelector('.progress');
    if (progress) {
      progress.style.width = progressPercent + '%';
    }

    // Add or update percentage display
    var percentDisplay = progressBar.querySelector('.percent-display');
    if (!percentDisplay) {
      percentDisplay = document.createElement('div');
      percentDisplay.className = 'percent-display';
      progressBar.appendChild(percentDisplay);
    }

    // Update the percentage text
    percentDisplay.textContent = Math.round(progressPercent) + '%';
  }
}

// Quiz functionality
function handleAnswer(questionId, value, isMultiselect) {
  if (isMultiselect) {
    // Initialize as array if not exists
    if (!Array.isArray(quizState.answers[questionId])) {
      quizState.answers[questionId] = [];
    }

    var index = quizState.answers[questionId].indexOf(value);
    if (index === -1) {
      // Add value if not present
      quizState.answers[questionId].push(value);
    } else {
      // Remove value if present
      quizState.answers[questionId].splice(index, 1);
    }
  } else {
    quizState.answers[questionId] = value;
  }

  updateQuizDisplay();
  updateProgressBar();
}

function handleNext() {
  var currentQuestion = questions[quizState.currentStep];
  var currentAnswer = quizState.answers[currentQuestion.id];

  if (!currentAnswer || Array.isArray(currentAnswer) && currentAnswer.length === 0) {
    alert('Please select at least one option before continuing.');
    return;
  }

  // Check if we've reached the last question
  if (quizState.currentStep < questions.length - 1) {
    quizState.currentStep++;
    updateQuizDisplay();
    updateProgressBar();
  } else {
    showResults();
  }
}

function handlePrevious() {
  if (quizState.currentStep > -1) {
    quizState.currentStep--;
    updateQuizDisplay();
    updateProgressBar();
  }
}

function handleInputChange(event) {
  var _event$target = event.target,
      name = _event$target.name,
      value = _event$target.value;

  quizState.contactInfo[name] = value;
}

function isOptionSelected(questionId, optionValue) {
  var answer = quizState.answers[questionId];
  if (!answer) return false;

  if (Array.isArray(answer)) {
    // For multiselect questions (checkboxes)
    return answer.includes(optionValue);
  } else {
    // For single select questions (radio buttons)
    return answer === optionValue;
  }
}

function updateQuizDisplay() {
  var quizContent = document.querySelector('.quiz-content-k12');
  if (!quizContent) return;

  // Clear any existing selected classes
  var existingOptions = quizContent.querySelectorAll('.option');
  existingOptions.forEach(function (option) {
    return option.classList.remove('selected');
  });

  if (quizState.showResults) {
    renderResults(quizContent);
    return;
  }

  var container = quizContent.querySelector('.quiz-container-k12');

  // Update progress bar
  updateProgressBar();

  // Special case for intro page (currentStep = -1)
  if (quizState.currentStep === -1) {
    var firstQuestion = questions[0];
    var firstQuestionOptionsHtml = '';

    firstQuestion.options.forEach(function (option, index) {
      var isChecked = quizState.answers[firstQuestion.id] === option ? 'checked' : '';
      var isSelected = quizState.answers[firstQuestion.id] === option ? 'selected' : '';

      firstQuestionOptionsHtml += '\n        <div class="option ' + isSelected + '">\n          <input type="radio"\n                 name="' + firstQuestion.id + '"\n                 value="' + option + '"\n                 id="' + firstQuestion.id + '_' + index + '"\n                 ' + isChecked + '>\n          <label for="' + firstQuestion.id + '_' + index + '">' + option + '</label>\n        </div>\n      ';
    });

    container.innerHTML = '\n      <div class="quiz-step quiz-intro">\n        <div class="intro-container">\n          <div class="intro-content">\n            <p><b>Is your district making decisions with complete, timely data, or are you filling in the gaps manually?</b></p>\n            <p>This quick assessment helps K-12 leaders understand how well their data systems support visibility, decision-making, and accountability.</p>\n            <p>Once complete, you\'ll receive a personalized readiness score and recommendations for where to focus next.</p>\n            <p>In just six questions, we\'ll help you identify how integrated, accessible, and actionable your data is and where to strengthen your foundation for better outcomes.</p>\n          </div>\n          <div class="first-question">\n            <div class="quiz-question">\n              ' + (firstQuestion.headline ? '<p class="prehead">' + firstQuestion.headline + '</p>' : '') + '\n              <h3>' + firstQuestion.text + '</h3>\n              <div class="options">\n                ' + firstQuestionOptionsHtml + '\n              </div>\n            </div>\n            <div class="navigation intro-nav">\n              <button type="button" class="next-btn">Next</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    ';

    // Add event listeners for the first question options
    var firstQuestionOptions = container.querySelectorAll('.first-question .option');
    firstQuestionOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        var input = this.querySelector('input');
        var questionId = input.name;
        var value = input.value;

        // Handle intro content fade out
        var introContent = document.querySelector('.intro-content');
        var firstQuestionDiv = document.querySelector('.first-question');

        if (introContent && firstQuestionDiv) {
          introContent.classList.add('hide-intro');
          firstQuestionDiv.classList.add('full-width');
        }

        // Clear other selections
        var allOptions = document.querySelectorAll('input[name="' + questionId + '"]');
        allOptions.forEach(function (opt) {
          opt.checked = false;
          opt.closest('.option').classList.remove('selected');
        });

        quizState.answers[questionId] = value;
        this.classList.add('selected');
        input.checked = true;
      });
    });

    // Add event listener for the Next button
    container.querySelector('.next-btn').addEventListener('click', function () {
      if (!quizState.answers[firstQuestion.id]) {
        alert('Please select an option before continuing.');
        return;
      }

      quizState.currentStep = 1; // Move to second question (skip first since it's already answered)
      updateQuizDisplay();
    });

    return;
  }

  var question = questions[quizState.currentStep];

  // Check if question is defined before proceeding
  if (!question) {
    console.error('Question is undefined for step:', quizState.currentStep);
    return;
  }

  var savedAnswer = quizState.answers[question.id];

  var optionsHtml = '';
  question.options.forEach(function (option, index) {
    var isChecked = '';
    var isSelected = '';

    if (question.type === 'multiselect') {
      // For multiselect, savedAnswer is an array
      var savedAnswers = Array.isArray(savedAnswer) ? savedAnswer : [];
      isChecked = savedAnswers.includes(option) ? 'checked' : '';
      isSelected = savedAnswers.includes(option) ? 'selected' : '';
    } else {
      // For single select
      isChecked = savedAnswer === option ? 'checked' : '';
      isSelected = savedAnswer === option ? 'selected' : '';
    }

    optionsHtml += '\n      <div class="option ' + isSelected + '">\n        <input type="' + (question.type === 'multiselect' ? 'checkbox' : 'radio') + '"\n               name="' + question.id + '"\n               value="' + option + '"\n               id="' + question.id + '_' + index + '"\n               ' + isChecked + '>\n        <label for="' + question.id + '_' + index + '">' + option + '</label>\n      </div>\n    ';
  });

  container.innerHTML = '\n    <div class="quiz-step">\n      <div class="quiz-question">\n        ' + (question.headline ? '<p class="prehead">' + question.headline + '</p>' : '') + '\n        <h3>' + question.text + '</h3>\n        <div class="options">\n          ' + optionsHtml + '\n        </div>\n      </div>\n      <div class="navigation">\n        ' + (quizState.currentStep >= 0 ? '<button type="button" class="prev-btn">Previous</button>' : '') + '\n        <button type="button" class="next-btn">\n          ' + (quizState.currentStep === questions.length ? 'Submit' : 'Next') + '\n        </button>\n      </div>\n    </div>\n  ';

  // Add event listeners
  container.querySelector('.next-btn').addEventListener('click', handleNext);
  if (quizState.currentStep >= 0) {
    container.querySelector('.prev-btn').addEventListener('click', handlePrevious);
  }

  var options = container.querySelectorAll('.option');
  options.forEach(function (option) {
    var input = option.querySelector('input');

    // Only handle clicks on the option div itself
    option.addEventListener('click', function (event) {
      // Prevent handling if the click was on the input or label
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'LABEL') {
        return;
      }

      if (input) {
        var isMultiselect = input.type === 'checkbox';

        // Manually toggle the checkbox state
        if (isMultiselect) {
          input.checked = !input.checked;
          // Dispatch change event manually
          input.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });

    // Handle input changes
    input.addEventListener('change', function (event) {
      var questionId = input.getAttribute('name');
      var isMultiselect = input.type === 'checkbox';

      // Update visual state
      if (isMultiselect) {
        option.classList.toggle('selected', input.checked);
      } else {
        var allOptions = option.closest('.options').querySelectorAll('.option');
        allOptions.forEach(function (opt) {
          return opt.classList.remove('selected');
        });
        option.classList.add('selected');
      }

      // Update quiz state
      handleAnswer(questionId, input.value, isMultiselect);
    });
  });
}

function addOptionEventListeners(options) {
  options.forEach(function (option) {
    option.addEventListener('click', function () {
      var input = this.querySelector('input');
      var questionId = input.name;
      var value = input.value;
      var isMultiselect = input.type === 'checkbox';

      if (isMultiselect) {
        // For multiselect, toggle the selection
        if (!quizState.answers[questionId]) {
          quizState.answers[questionId] = [];
        }

        var index = quizState.answers[questionId].indexOf(value);
        if (index === -1) {
          quizState.answers[questionId].push(value);
          this.classList.add('selected');
          input.checked = true;
        } else {
          quizState.answers[questionId].splice(index, 1);
          this.classList.remove('selected');
          input.checked = false;
        }
      } else {
        // For single select, clear other selections
        var allOptions = document.querySelectorAll('input[name="' + questionId + '"]');
        allOptions.forEach(function (opt) {
          opt.checked = false;
          opt.closest('.option').classList.remove('selected');
        });

        // Set the selected option
        quizState.answers[questionId] = value;
        this.classList.add('selected');
        input.checked = true;
      }
    });
  });
}

function renderResults(container) {
  var html = '\n    <div class="quiz-results">\n      ' + (!quizState.formSubmitted ? '\n        <h3>Almost Done!</h3>\n        <p>Fill out the form below to receive your personalized assessment.</p>\n        <div id="hubspot-form-container" class="hbspt-form"></div>\n      ' : '\n        <h3>Thank You!</h3>\n        <p>Your score reflects how well your district\'s data systems support visibility, decision-making, and accountability across schools and programs.</p>\n        ' + function () {
    var recommendation = getRecommendation();

    return '\n            <div class="recommendation">\n              <h4>' + recommendation.title + '</h4>\n              <p>' + recommendation.range + '</p>\n              <p>' + recommendation.description + '</p>\n              <p class=\'space-above\'><strong>Where to focus next:</strong></p>\n              <ul>\n                ' + recommendation.focusAreas.map(function (area) {
      return '<li>' + area + '</li>';
    }).join('') + '\n              </ul>\n              <p class=\'space-above\'>Our team will be in touch to help you reach your state\'s potential.</p>\n            </div>\n          ';
  }() + '\n      ') + '\n    </div>\n  ';

  container.innerHTML = html;

  if (!quizState.formSubmitted) {
    // Create HubSpot form
    hbspt.forms.create({
      portalId: '7120550',
      formId: '2a815988-197c-4f4c-a664-5571b54b7eec',
      region: 'na1',
      target: '#hubspot-form-container',
      onFormReady: function onFormReady($form) {
        var recommendation = getRecommendation();
        var surveyResultField = $form.find('input[name="k12_survey_result"]');
        if (surveyResultField.length) {
          surveyResultField.val(recommendation.title);
        }

        var surveyInfoField = $form.find('input[name="k12_survey_info"]');
        if (surveyInfoField.length) {
          surveyInfoField.val(formatSurveyAnswers());
        }
      },
      onFormSubmitted: function onFormSubmitted() {
        quizState.formSubmitted = true;
        updateQuizDisplay();
      }
    });
  }
}

function showResults() {
  quizState.showResults = true;
  updateQuizDisplay();
}

function scoreFromAnswer(questionId, answerText) {
  var question = questions.find(function (q) {
    return q.id === questionId;
  });
  if (!question) {
    return 0;
  }
  if (!answerText || typeof answerText !== 'string') {
    return 0;
  }
  var selectedIndex = question.options.indexOf(answerText);
  if (selectedIndex === -1) {
    return 0;
  }
  if (!Array.isArray(question.points) || question.points[selectedIndex] === undefined) {
    return 0;
  }
  return question.points[selectedIndex];
}

function getTotalScore() {
  var total = 0;
  questions.forEach(function (q) {
    total += scoreFromAnswer(q.id, quizState.answers[q.id]);
  });
  return total;
}

function getReadinessPercent() {
  var total = getTotalScore();
  return total / 24 * 100;
}

function formatSurveyAnswers() {
  var answers = [];

  answers.push('K12 Data Readiness Assessment');

  // Add scored questions
  questions.forEach(function (q) {
    answers.push(q.id + ': ' + (quizState.answers[q.id] || 'Not provided'));
  });

  // Sanitize the final string for safe use in input value
  var joinedAnswers = answers.join('\n');
  var div = document.createElement('div');
  div.textContent = joinedAnswers;
  return div.innerHTML;
}

function getRecommendation() {
  var percent = getReadinessPercent();

  if (percent < 50) {
    return {
      title: 'Foundational Visibility',
      range: 'Score range: 0-49%',
      description: 'Your district is operating with limited visibility across systems. Data is fragmented, and decisions often rely on incomplete or outdated information.',
      focusAreas: ['Establish a unified data governance plan with shared definitions', 'Connect core systems', 'Build a baseline view of performance across the district']
    };
  }

  if (percent < 80) {
    return {
      title: 'Operational Alignment',
      range: 'Score range: 50-79%',
      description: 'You have meaningful capabilities in place, but gaps in consistency and access limit your ability to act quickly and confidently.',
      focusAreas: ['Strengthen integration', 'Improve real-time visibility', 'Equip schools with usable insights to drive better outcomes']
    };
  }

  return {
    title: 'Strategic Readiness',
    range: 'Score range: 80-100%',
    description: 'Your district is well positioned with strong data foundations and visibility across systems.',
    focusAreas: ['Scale decision-making', 'Strengthen outcome measurement', 'Drive continuous improvement across schools and programs']
  };
}

// Initialize quiz when DOM is loaded
jQuery(document).ready(function ($) {
  var quizContent = document.querySelector('.quiz-content-k12');
  if (!quizContent) {
    return;
  }

  var container = quizContent.querySelector('.quiz-container-k12');
  if (!container) {
    return;
  }

  // Make functions globally available (only when k12 quiz exists)
  window.prevStep = function () {
    if (quizState.currentStep > -1) {
      quizState.currentStep--;
      updateQuizDisplay();
      updateProgressBar();
    }
  };

  window.nextStep = function () {
    if (quizState.currentStep < questions.length - 1) {
      quizState.currentStep++;
      updateQuizDisplay();
      updateProgressBar();
    } else {
      quizState.showResults = true;
      updateQuizDisplay();
    }
  };

  updateQuizDisplay();
  updateProgressBar();

  // Check for #start-quiz hash in URL to scroll to quiz section if present
  if (window.location.hash === '#start-quiz') {
    // Scroll to the quiz section
    setTimeout(function () {
      $('html, body').animate({
        scrollTop: $('.section-quiz').offset().top - 100
      }, 500);
    }, 500); // Small delay to ensure everything is loaded properly
  }
});

},{}],41:[function(require,module,exports){
'use strict';

// Quiz configuration and state management
var quizState = {
  currentStep: -1, // Start with intro page
  answers: {},
  contactInfo: {
    name: '',
    company: '',
    email: '',
    phone: '',
    role: '',
    companySize: '',
    industrySubsector: '',
    dataSystems: ''
  },
  showResults: false,
  formSubmitted: false
};

// Quiz questions configuration
var questions = [{
  id: 'outcomes_data_linkage',
  text: 'How effectively can your agency link training participation to employment and wage outcomes today?',
  options: ['Statewide, automated linkage across longitudinal data systems and programs (e.g., WIOA, UI wage records, training providers), regularly used for reporting and decision making', 'Linked for major programs or providers, with some manual processes', 'Limited linkage or pilot efforts; not yet reliable for consistent reporting', 'Minimal or ad hoc linkage', 'Not currently possible or not sure'],
  points: [4, 3, 2, 1, 0]
}, {
  id: 'shared_definitions_governance',
  text: 'How mature are your shared definitions and governance for priority occupations, credentials of value, and training programs?',
  options: ['Standardized definitions statewide, actively governed across partners', 'Mostly aligned, with some variation by program or partner', 'Definitions exist but are inconsistently applied or outdated', 'Definitions are informal or agency-specific', 'No shared definitions or not sure'],
  points: [4, 3, 2, 1, 0]
}, {
  id: 'citizen_facing_guidance',
  text: 'How well do your digital tools help jobseekers understand training options and career pathways tied to in-demand occupations?',
  options: ['AI-enabled tools provide personalized, real-time guidance statewide', 'Digital tools exist but rely on static rules or limited personalization', 'Basic listings or informational pages with limited decision support', 'Minimal digital guidance', 'No digital guidance or not sure'],
  points: [4, 3, 2, 1, 0]
}, {
  id: 'staff_enablement',
  text: 'How well are frontline staff supported by modern tools that streamline intake, referrals, and guidance?',
  options: ['Integrated tools support consistent workflows and reduce manual effort', 'Tools support some functions but require workarounds', 'Staff rely heavily on manual processes or disconnected systems', 'Limited technology support for staff workflows', 'Not sure or no consistent tools in place'],
  points: [4, 3, 2, 1, 0]
}, {
  id: 'program_performance_readiness',
  text: 'How prepared is your agency to evaluate training programs against outcome expectations such as completion and employment alignment?',
  options: ['Outcome metrics are defined, tracked, and used in approvals and oversight', 'Metrics exist but are not consistently applied', 'Metrics are informal or limited to basic placement rates', 'Minimal performance tracking', 'Not sure or no formal evaluation approach'],
  points: [4, 3, 2, 1, 0]
}, {
  id: 'roi_communication',
  text: 'How effectively can your agency communicate the value and ROI of training programs to leadership and stakeholders using dashboards?',
  options: ['Clear, trusted dashboards and ROI metrics regularly inform funding and policy decisions', 'Dashboards or reports exist, but ROI is not consistently quantified or decision-ready', 'Reporting focuses mainly on counts or compliance metrics with limited dashboard use', 'Limited ability to communicate ROI beyond static reports or spreadsheets', 'Not sure or no established approach'],
  points: [4, 3, 2, 1, 0]
}];

// Function to update progress bar
function updateProgressBar() {
  var totalSteps = questions.length;
  var currentStep = quizState.currentStep + 1; // Add 1 because currentStep is 0-indexed
  var progressPercent = quizState.currentStep >= 0 ? currentStep / totalSteps * 100 : 0;

  var progressBar = document.querySelector('.progress-bar');
  if (progressBar) {
    // Hide progress bar if progress is 0%
    if (progressPercent === 0) {
      progressBar.style.opacity = '0';
      progressBar.style.visibility = 'hidden';
    } else {
      progressBar.style.opacity = '1';
      progressBar.style.visibility = 'visible';
    }

    var progress = progressBar.querySelector('.progress');
    if (progress) {
      progress.style.width = progressPercent + '%';
    }

    // Add or update percentage display
    var percentDisplay = progressBar.querySelector('.percent-display');
    if (!percentDisplay) {
      percentDisplay = document.createElement('div');
      percentDisplay.className = 'percent-display';
      progressBar.appendChild(percentDisplay);
    }

    // Update the percentage text
    percentDisplay.textContent = Math.round(progressPercent) + '%';
  }
}

// Quiz functionality
function handleAnswer(questionId, value, isMultiselect) {
  if (isMultiselect) {
    // Initialize as array if not exists
    if (!Array.isArray(quizState.answers[questionId])) {
      quizState.answers[questionId] = [];
    }

    var index = quizState.answers[questionId].indexOf(value);
    if (index === -1) {
      // Add value if not present
      quizState.answers[questionId].push(value);
    } else {
      // Remove value if present
      quizState.answers[questionId].splice(index, 1);
    }
  } else {
    quizState.answers[questionId] = value;
  }

  updateQuizDisplay();
  updateProgressBar();
}

function handleNext() {
  // Special case for intro page
  if (quizState.currentStep === -1) {
    quizState.currentStep++;
    updateQuizDisplay();
    updateProgressBar();
    return;
  }

  var currentQuestion = questions[quizState.currentStep];
  var currentAnswer = quizState.answers[currentQuestion.id];

  if (!currentAnswer || Array.isArray(currentAnswer) && currentAnswer.length === 0) {
    alert('Please select at least one option before continuing.');
    return;
  }

  if (quizState.currentStep < questions.length - 1) {
    quizState.currentStep++;
    updateQuizDisplay();
    updateProgressBar();
  } else {
    showResults();
  }
}

function handlePrevious() {
  if (quizState.currentStep > -1) {
    quizState.currentStep--;
    updateQuizDisplay();
    updateProgressBar();
  }
}

function handleInputChange(event) {
  var _event$target = event.target,
      name = _event$target.name,
      value = _event$target.value;

  quizState.contactInfo[name] = value;
}

function isOptionSelected(questionId, optionValue) {
  var answer = quizState.answers[questionId];
  if (!answer) return false;

  if (Array.isArray(answer)) {
    // For multiselect questions (checkboxes)
    return answer.includes(optionValue);
  } else {
    // For single select questions (radio buttons)
    return answer === optionValue;
  }
}

function updateQuizDisplay() {
  var quizContent = document.querySelector('.quiz-content-workforce');
  if (!quizContent) return;

  // Clear any existing selected classes
  var existingOptions = quizContent.querySelectorAll('.option');
  existingOptions.forEach(function (option) {
    return option.classList.remove('selected');
  });

  if (quizState.showResults) {
    renderResults(quizContent);
    return;
  }

  var container = quizContent.querySelector('.quiz-container-workforce');

  // Update progress bar
  updateProgressBar();

  // Special case for intro page (currentStep = -1)
  if (quizState.currentStep === -1) {
    // Get the first question to display alongside intro
    var firstQuestion = questions[0];
    var firstQuestionOptionsHtml = '';

    firstQuestion.options.forEach(function (option, index) {
      var isChecked = isOptionSelected(firstQuestion.id, option) ? 'checked' : '';
      var isSelected = isOptionSelected(firstQuestion.id, option) ? 'selected' : '';

      firstQuestionOptionsHtml += '\n        <div class="option ' + isSelected + '">\n          <input type="' + (firstQuestion.type === 'multiselect' ? 'checkbox' : 'radio') + '"\n                 name="' + firstQuestion.id + '"\n                 value="' + option + '"\n                 id="' + firstQuestion.id + '_' + index + '"\n                 ' + isChecked + '>\n          <label for="' + firstQuestion.id + '_' + index + '">' + option + '</label>\n        </div>\n      ';
    });

    container.innerHTML = '\n      <div class="quiz-step quiz-intro">\n        <div class="intro-container">\n          <div class="intro-content">\n            <p>Workforce Pell, new USDOL guidance, and rising expectations around outcomes are converging in 2026.</p>\n            <p>Workforce Pell is accelerating cross-agency coordination and increasing focus on measurable outcomes. This brief readiness quiz helps workforce agencies assess preparedness across three core pillars: data integration, AI-enabled career navigation, and ROI and accountability. The assessment is free and takes less than three minutes to complete.</p>\n            <p>Once complete, you\'ll receive a personalized recommendation for your top focus area.</p>\n            <p>Your responses are confidential and never shared publicly.</p>\n          </div>\n          <div class="first-question">\n            <div class="quiz-question">\n              <h3>' + firstQuestion.text + '</h3>\n              <div class="options">\n                ' + firstQuestionOptionsHtml + '\n              </div>\n            </div>\n            <div class="navigation intro-nav">\n              <button type="button" class="next-btn">Next</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    ';

    // Add event listeners for the first question options
    addOptionEventListeners(container.querySelectorAll('.first-question .option'));

    // Add event listener for the Next button
    container.querySelector('.next-btn').addEventListener('click', function () {
      var currentQuestion = questions[0];
      var currentAnswer = quizState.answers[currentQuestion.id];

      if (!currentAnswer || Array.isArray(currentAnswer) && currentAnswer.length === 0) {
        alert('Please select at least one option before continuing.');
        return;
      }

      quizState.currentStep = 1; // Skip to second question since we've already shown the first
      updateQuizDisplay();
    });

    return;
  }

  var question = questions[quizState.currentStep];

  // Check if question is defined before proceeding
  if (!question) {
    console.error('Question is undefined for step:', quizState.currentStep);
    return;
  }

  var savedAnswer = quizState.answers[question.id];

  var optionsHtml = '';
  question.options.forEach(function (option, index) {
    var isChecked = '';
    var isSelected = '';

    if (question.type === 'multiselect') {
      // For multiselect, savedAnswer is an array
      var savedAnswers = Array.isArray(savedAnswer) ? savedAnswer : [];
      isChecked = savedAnswers.includes(option) ? 'checked' : '';
      isSelected = savedAnswers.includes(option) ? 'selected' : '';
    } else {
      // For single select
      isChecked = savedAnswer === option ? 'checked' : '';
      isSelected = savedAnswer === option ? 'selected' : '';
    }

    optionsHtml += '\n      <div class="option ' + isSelected + '">\n        <input type="' + (question.type === 'multiselect' ? 'checkbox' : 'radio') + '"\n               name="' + question.id + '"\n               value="' + option + '"\n               id="' + question.id + '_' + index + '"\n               ' + isChecked + '>\n        <label for="' + question.id + '_' + index + '">' + option + '</label>\n      </div>\n    ';
  });

  container.innerHTML = '\n    <div class="quiz-step">\n      <div class="quiz-question">\n        <h3>' + question.text + '</h3>\n        <div class="options">\n          ' + optionsHtml + '\n        </div>\n      </div>\n      <div class="navigation">\n        ' + (quizState.currentStep > 0 ? '<button type="button" class="prev-btn">Previous</button>' : '') + '\n        <button type="button" class="next-btn">\n          ' + (quizState.currentStep === questions.length - 1 ? 'Submit' : 'Next') + '\n        </button>\n      </div>\n    </div>\n  ';

  // Add event listeners
  container.querySelector('.next-btn').addEventListener('click', handleNext);
  if (quizState.currentStep > 0) {
    container.querySelector('.prev-btn').addEventListener('click', handlePrevious);
  }

  var options = container.querySelectorAll('.option');
  options.forEach(function (option) {
    var input = option.querySelector('input');

    // Only handle clicks on the option div itself
    option.addEventListener('click', function (event) {
      // Prevent handling if the click was on the input or label
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'LABEL') {
        return;
      }

      if (input) {
        var isMultiselect = input.type === 'checkbox';

        // Manually toggle the checkbox state
        if (isMultiselect) {
          input.checked = !input.checked;
          // Dispatch change event manually
          input.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });

    // Handle input changes
    input.addEventListener('change', function (event) {
      var questionId = input.getAttribute('name');
      var isMultiselect = input.type === 'checkbox';

      // Update visual state
      if (isMultiselect) {
        option.classList.toggle('selected', input.checked);
      } else {
        var allOptions = option.closest('.options').querySelectorAll('.option');
        allOptions.forEach(function (opt) {
          return opt.classList.remove('selected');
        });
        option.classList.add('selected');
      }

      // Update quiz state
      handleAnswer(questionId, input.value, isMultiselect);
    });
  });
}

function addOptionEventListeners(options) {
  options.forEach(function (option) {
    option.addEventListener('click', function () {
      var input = this.querySelector('input');
      var questionId = input.name;
      var value = input.value;
      var isMultiselect = input.type === 'checkbox';

      // Handle intro content fade out if this is the first question
      if (quizState.currentStep === -1) {
        var introContent = document.querySelector('.intro-content');
        var firstQuestion = document.querySelector('.first-question');

        if (introContent && firstQuestion) {
          // Add hide-intro class to fade out the intro content
          introContent.classList.add('hide-intro');

          // Make the first question take full width
          firstQuestion.classList.add('full-width');
        }
      }

      if (isMultiselect) {
        // For multiselect, toggle the selection
        if (!quizState.answers[questionId]) {
          quizState.answers[questionId] = [];
        }

        var index = quizState.answers[questionId].indexOf(value);
        if (index === -1) {
          quizState.answers[questionId].push(value);
          this.classList.add('selected');
          input.checked = true;
        } else {
          quizState.answers[questionId].splice(index, 1);
          this.classList.remove('selected');
          input.checked = false;
        }
      } else {
        // For single select, clear other selections
        var allOptions = document.querySelectorAll('input[name="' + questionId + '"]');
        allOptions.forEach(function (opt) {
          opt.checked = false;
          opt.closest('.option').classList.remove('selected');
        });

        // Set the selected option
        quizState.answers[questionId] = value;
        this.classList.add('selected');
        input.checked = true;
      }
    });
  });
}

function renderResults(container) {
  var html = '\n    <div class="quiz-results">\n      ' + (!quizState.formSubmitted ? '\n        <h3>Almost Done!</h3>\n        <p>Fill out the form below to receive your personalized assessment.</p>\n        <div id="hubspot-form-container" class="hbspt-form"></div>\n      ' : '\n        <h3>Thank You!</h3>\n        <p>Based on your answers, here is your Workforce Pell readiness score:</p>\n        ' + function () {
    var recommendation = getRecommendation();

    return '\n            <div class="recommendation">\n              <h4>' + recommendation.title + '</h4>\n              <p>' + recommendation.range + '</p>\n              <p>' + recommendation.description + '</p>\n              <p>Our team will be in touch to help you reach your Workforce Pell potential.</p>\n            </div>\n          ';
  }() + '\n      ') + '\n    </div>\n  ';

  container.innerHTML = html;

  if (!quizState.formSubmitted) {
    // Create HubSpot form
    hbspt.forms.create({
      portalId: '7120550',
      formId: '40d2dbf4-73c7-478e-aff5-90beb711dea8',
      region: 'na1',
      target: '#hubspot-form-container',
      onFormReady: function onFormReady($form) {
        var recommendation = getRecommendation();
        var surveyResultField = $form.find('input[name="workforce_survey_result"]');
        if (surveyResultField.length) {
          surveyResultField.val(recommendation.title);
        }

        var surveyInfoField = $form.find('input[name="workforce_survey_info"]');
        if (surveyInfoField.length) {
          surveyInfoField.val(formatSurveyAnswers());
        }
      },
      onFormSubmitted: function onFormSubmitted() {
        quizState.formSubmitted = true;
        updateQuizDisplay();
      }
    });
  }
}

function showResults() {
  quizState.showResults = true;
  updateQuizDisplay();
}

function scoreFromAnswer(questionId, answerText) {
  var question = questions.find(function (q) {
    return q.id === questionId;
  });
  if (!question) {
    return 0;
  }
  if (!answerText || typeof answerText !== 'string') {
    return 0;
  }
  var selectedIndex = question.options.indexOf(answerText);
  if (selectedIndex === -1) {
    return 0;
  }
  if (!Array.isArray(question.points) || question.points[selectedIndex] === undefined) {
    return 0;
  }
  return question.points[selectedIndex];
}

function getTotalScore() {
  var total = 0;
  questions.forEach(function (q) {
    total += scoreFromAnswer(q.id, quizState.answers[q.id]);
  });
  return total;
}

function getReadinessPercent() {
  var total = getTotalScore();
  return total / 24 * 100;
}

function formatSurveyAnswers() {
  var answers = [];

  answers.push('Workforce Pell Readiness Assessment');

  questions.forEach(function (q) {
    answers.push(q.id + ': ' + (quizState.answers[q.id] || 'Not provided'));
  });

  // Sanitize the final string for safe use in input value
  var joinedAnswers = answers.join('\n');
  var div = document.createElement('div');
  div.textContent = joinedAnswers;
  return div.innerHTML;
}

function getRecommendation() {
  var percent = getReadinessPercent();

  if (percent < 50) {
    return {
      title: 'Tier 1: Foundational Readiness',
      range: 'Score range: 0–49%',
      description: 'Your agency is aware of Workforce Pell but still building the core capabilities needed for consistent reporting, navigation, and outcome storytelling. Focus first on alignment, ownership, and foundational data connections.'
    };
  }

  if (percent < 80) {
    return {
      title: 'Tier 2: Operational Readiness',
      range: 'Score range: 50–79%',
      description: 'You have meaningful capabilities in place, but scale and consistency remain challenges. Strengthening integration, standardization, and decision-ready insights will position you to respond quickly as guidance becomes clearer.'
    };
  }

  return {
    title: 'Tier 3: Strategic Readiness',
    range: 'Score range: 80–100%',
    description: 'Your agency is well positioned to operationalize Workforce Pell expectations with strong data foundations, modern navigation tools, and credible ROI insights. The next opportunity is continuous improvement and cross-partner leadership.'
  };
}

// Initialize quiz when DOM is loaded
jQuery(document).ready(function ($) {
  var quizContent = document.querySelector('.quiz-content-workforce');
  if (!quizContent) {
    return;
  }

  var container = quizContent.querySelector('.quiz-container-workforce');
  if (!container) {
    return;
  }

  // Make functions globally available (only when workforce quiz exists)
  window.prevStep = function () {
    if (quizState.currentStep > -1) {
      quizState.currentStep--;
      updateQuizDisplay();
      updateProgressBar();
    }
  };

  window.nextStep = function () {
    if (quizState.currentStep < questions.length - 1) {
      quizState.currentStep++;
      updateQuizDisplay();
      updateProgressBar();
    } else {
      quizState.showResults = true;
      updateQuizDisplay();
    }
  };

  updateQuizDisplay();
  updateProgressBar();

  // Check for #start-quiz hash in URL to scroll to quiz section if present
  if (window.location.hash === '#start-quiz') {
    // Scroll to the quiz section
    setTimeout(function () {
      $('html, body').animate({
        scrollTop: $('.section-quiz').offset().top - 100
      }, 500);
    }, 500); // Small delay to ensure everything is loaded properly
  }
});

},{}],42:[function(require,module,exports){
'use strict';

function initDrawerCta() {
  //console.log('Initializing drawer CTA');
  var $drawer = $('.drawer-cta');
  //console.log('Found drawer elements:', $drawer.length);
  if (!$drawer.length) return;

  var isCollapsed = false;
  var scrollTimer = null;
  var scrollThreshold = 100;

  function toggleDrawer() {
    //console.log('Toggle drawer, current state:', isCollapsed);
    isCollapsed = !isCollapsed;
    $drawer.toggleClass('is-collapsed');
    $drawer.find('.drawer-cta__toggle').attr('aria-expanded', !isCollapsed);
  }

  function handleScroll() {
    if (scrollTimer) {
      clearTimeout(scrollTimer);
    }

    scrollTimer = setTimeout(function () {
      var scrollTop = $(window).scrollTop();
      //console.log('Scroll position:', scrollTop);
      if (scrollTop > scrollThreshold && !isCollapsed) {
        toggleDrawer();
      }
    }, 150);
  }

  // Bind events
  $drawer.find('.drawer-cta__toggle').on('click', toggleDrawer);
  $(window).on('scroll', handleScroll);

  // Initialize
  //console.log('Drawer CTA initialized');
}

// Initialize on document ready
$(function () {
  //console.log('Document ready');
  initDrawerCta();
});

},{}],43:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    alertSize();

    if ($('.m-alert').length) {
      if (sessionStorage.getItem('alertState') != 'dismissed') {
        rezAlert();
      } else {
        $('.m-alert').hide();
        $('body').css('padding-bottom', 0);
      }
    }
  });

  $(window).on('resize orientationchange', function () {
    alertSize();
  });

  function rezAlert() {
    $('.m-alert').css('opacity', 1);

    $('.m-alert .close').on('click', function () {
      $('.m-alert').hide();
      $('body').css('padding-bottom', 0);
      sessionStorage.setItem('alertState', 'dismissed');
    });
  }

  function alertSize() {
    $('body').css('padding-bottom', 0);
    if ($('.m-alert').length) {
      var ah = $('.m-alert').height();
      $('body').css('padding-bottom', ah);
    }
  }
});

},{}],44:[function(require,module,exports){
'use strict';

$(function () {
  $(window).scroll(function () {
    var curPos = $(this).scrollTop(),
        wh = $(window).height();
    //console.log('currentPos: ' + curPos)
    var windowBottom = $(this).scrollTop() + wh;
    windowBottom = windowBottom - 100;
    //console.log('winBottom: ' + windowBottom)
    if (curPos > 500) {
      $('.back-to-top').addClass('show');
      // $('.back-to-top').fadeIn(200)
    } else {
      $('.back-to-top').removeClass('show');
    }

    // change color of back to top according to section under it 
    $('section, footer').each(function () {

      var top_of_element = $(this).offset().top;
      var bottom_of_element = $(this).offset().top + $(this).outerHeight();
      var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight() - 100;
      var top_of_screen = $(window).scrollTop();

      if (bottom_of_screen > top_of_element && top_of_screen < bottom_of_element) {
        var theClass = $(this).attr("class").match(/bg[\w-]*\b/);
        if (theClass != null) {
          $('#backToTop').attr('data-bg', theClass[0]);
        }
      }
    }); // end changing color

  });

  $('.back-to-top').on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 200);
  });
});

},{}],45:[function(require,module,exports){
"use strict";

$(function () {
  // Initialize dataLayer if it doesn't exist
  window.dataLayer = window.dataLayer || [];

  function createCookie(name, value, days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      var expires = "; expires=" + date.toGMTString();
    } else var expires = "";
    document.cookie = name + "=" + value + expires + "; path=/";
  }

  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1, c.length);
      }if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // Function to enable/disable scrolling
  function toggleBodyScroll(disable) {
    if (disable) {
      $('body').css({
        'overflow': 'hidden',
        'height': '100%'
      });
    } else {
      $('body').css({
        'overflow': '',
        'height': ''
      });
    }
  }

  // Function to hide cookie notice and overlay
  function hideCookieNotice() {
    $('.m-footer-cookies').hide();
    $('.cookie-overlay').hide();
    toggleBodyScroll(false);
    $('#hubspot-messages-iframe-container').addClass('no-cookie-notice');
  }

  // Function to send GA4 events anonymously
  function sendAnonymousGA4Event(eventName) {
    if (window.dataLayer) {
      window.dataLayer.push({
        'event': eventName,
        'anonymous': true
      });
      return true;
    } else {
      return false;
    }
  }

  // Make sure buttons are clickable by using direct event binding
  $(document).on('click', '#acceptCookies', function (e) {
    e.preventDefault();
    e.stopPropagation();
    console.log('Accept cookies clicked');
    // Send anonymous GA4 event before setting cookie
    sendAnonymousGA4Event('acceptCookies');
    hideCookieNotice();
    createCookie('cookies_accepted', 'true', 30);
    location.reload(true);
  });

  $(document).on('click', '#declineCookies', function (e) {
    e.preventDefault();
    e.stopPropagation();
    console.log('Decline cookies clicked');
    // Send anonymous GA4 event before setting cookie
    sendAnonymousGA4Event('declineCookies');
    hideCookieNotice();
    createCookie('cookies_accepted', 'false', 30);
    location.reload(true);
  });

  // Add event handler for the "Learn More" link
  $(document).on('click', '.cookies-link', function (e) {
    console.log('Learn more cookies clicked');
    // Send anonymous GA4 event
    sendAnonymousGA4Event('learnMoreCookies');
    // Don't prevent default here to allow navigation to the link target
  });

  // Add explicit click handlers to ensure buttons are clickable
  setTimeout(function () {
    $('#acceptCookies, #declineCookies').css('cursor', 'pointer');
  }, 500);

  var cookies = readCookie('cookies_accepted');

  if (cookies === null || cookies === '') {
    // Show cookie notice and overlay
    $('.m-footer-cookies').css('display', 'flex');
    $('.cookie-overlay').css('display', 'block');
    toggleBodyScroll(true);
  } else {
    // if no cookie notice shown, put hubspot chat thing at bottom
    $('#hubspot-messages-iframe-container').addClass('no-cookie-notice');
  }
});

},{}],46:[function(require,module,exports){
'use strict';

var _headerNav = require('../header-nav/header-nav');

jQuery(function ($) {
  $(document).ready(function () {
    $('.m-header-eyebrow-search-toggle').click(function (e) {
      e.preventDefault();
      if (_headerNav.$searchForm.is(':visible')) {
        _headerNav.$overlay.hide();
        $(this).removeClass('is-active');
        _headerNav.$searchForm.velocity('finish').velocity('slideUp', {
          duration: 250,
          easing: 'easeInOut'
        });
        (0, _headerNav.scrollReset)();
      } else {
        (0, _headerNav.hideAllTheThings)(false);
        _headerNav.$overlay.show();
        $(this).addClass('is-active');
        (0, _headerNav.scrollOverride)();
        _headerNav.$searchForm.velocity('finish').velocity('slideDown', {
          duration: 250,
          easing: 'easeInOut',
          complete: function complete() {
            $(this).find('[type="search"]').focus();
          }
        });
      }
    });
  });
});

},{"../header-nav/header-nav":47}],47:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollReset = exports.scrollOverride = exports.navBreakpoint = undefined;

var _utilities = require('../../../assets/src/js/utilities');

var $anchors = jQuery('.m-header-nav-thing > .mega-menu-label > .mega-menu-trigger'),
    $anchors2 = jQuery('.parent > .mega-nav-item > .mega-menu-label > .mega-menu-trigger'),
    $header = jQuery('.m-header'),
    navBreakpoint = 992,
    st = 0;

jQuery(function ($) {
  $(window).on('resize orientationchange', function () {
    var $dropdown = $('.mega-menu-trigger.is-active').siblings('.mega-nav');
    fullNavSize();
  });

  $(document).ready(function () {

    $('.mega-menu-trigger').mouseenter(function () {
      if (window.innerWidth >= navBreakpoint) {
        $('.m-header-nav').addClass('inverse');
      }
    });
    $('.mega-menu-trigger').mouseleave(function () {
      if (window.innerWidth >= navBreakpoint) {
        if (!$('.m-header-nav').hasClass('open')) {
          $('.m-header-nav').removeClass('inverse');
        }
      }
    });
    $('.m-header-nav-toggle2').click((0, _utilities.debounce)(function (e) {
      e.preventDefault();
      if ($('.m-header').hasClass('search-is-open')) {
        $('.m-header').removeClass('search-is-open');
        $('.m-header-nav-search').removeClass('opened');
      }
      if (!$(this).hasClass('is-active') || !$(this).data('is-open')) {
        $('.m-header-nav-nav:not(.scroll-nav)').velocity('finish').velocity('slideDown', {
          duration: 250,
          begin: function begin() {
            $header.css({
              'bottom': 0
            });
            if (window.innerWidth < navBreakpoint) {
              scrollOverride();
            }
          }
        });
        $('.m-header-nav-nav.scroll-nav').velocity('finish').velocity({
          translateX: [0, '-100%']
        }, {
          duration: 250,
          easing: 'easeInOut',
          display: 'block',
          complete: function complete() {
            // showDropdownSlick($dropdown)
            // showDropdownModels($dropdown)
          }
        });
        $(this).attr('data-is-open', 'true');
      } else {
        hideAllTheThings(true);
        $('.m-header-nav-nav:not(.scroll-nav)').velocity('finish').velocity('slideUp', {
          duration: 0,
          complete: function complete() {
            $header.css({
              'bottom': 'auto'
            });
            scrollReset();
          }
        });
        $('.m-header-nav-nav.scroll-nav').velocity('finish').velocity({
          translateX: ['-100%', 0]
        }, {
          duration: 250,
          easing: 'easeInOut',
          display: 'block',
          complete: function complete() {
            // showDropdownSlick($dropdown)
            // showDropdownModels($dropdown)
          }
        });
        $(this).attr('data-is-open', 'false');
      }
      $(this).toggleClass('is-active');
      $('.m-header-nav-nav').toggleClass('is-active');
    }, 500, true));

    $('.m-header-nav-toggle2:not(.scroll-only)').on('click', function () {
      $('.m-header-nav').toggleClass('inverse');
    });

    $('.m-header-nav-toggle2.scroll-only').on('click', function () {
      $('.m-header-nav').toggleClass('condensed');
      $('body').toggleClass('no-scroll');
      $('.m-header-nav-head').velocity('finish').velocity({
        translateX: [0, '100%']
      }, {
        duration: 200,
        easing: 'easeInOut',
        display: 'block'
      });
    });

    $('.m-header-nav-nav-close button').on('click', function () {
      $('.m-header-nav').toggleClass('condensed');
      $('body').toggleClass('no-scroll');
      $('.m-header-nav-head').velocity('finish').velocity({
        translateX: [0, '100%']
      }, {
        duration: 200,
        easing: 'easeInOut',
        display: 'block'
      });
      //$('.m-header-nav-toggle2').show();
      hideAllTheThings(true);
      $('.m-header-nav-nav:not(.scroll-nav)').velocity('finish').velocity('slideUp', {
        duration: 0,
        complete: function complete() {
          $header.css({
            'bottom': 'auto'
          });
          scrollReset();
        }
      });
      $('.m-header-nav-nav.scroll-nav').velocity('finish').velocity({
        translateX: ['-100%', 0]
      }, {
        duration: 250,
        easing: 'easeInOut',
        display: 'block',
        complete: function complete() {
          // showDropdownSlick($dropdown)
          // showDropdownModels($dropdown)
        }
      });
      $('.m-header-nav-toggle2').attr('data-is-open', 'false');
      $('.m-header-nav-toggle2').removeClass('is-active');
      $('.m-header-nav-nav').removeClass('is-active');
    });

    $('.m-header-nav-toggle.is-active').on('click', function () {
      // if( $(this).hasClass('is-active') ) {
      hideAllTheThings(true);
      // }
    });

    $anchors.click((0, _utilities.debounce)(function (e) {
      e.preventDefault();
      var $dropdown = $(this).siblings('.mega-nav');
      $anchors.removeClass('is-active');
      if (window.innerWidth >= navBreakpoint) {
        if ($dropdown.is(':visible')) {
          $('.m-header-nav').removeClass('open');
          $dropdown.removeClass('active-nav');
          hideDropdown($dropdown, false);
          // $overlay.hide()
          $('body').removeClass('no-scroll');
          scrollReset();
        } else {
          $('.m-header-nav').addClass('open');
          $(this).addClass('is-active');
          if (!$('.m-header-nav-nav').hasClass('scroll-nav')) {
            hideDropdown($('.mega-nav.active-nav'), true);
            $('.mega-nav.active-nav').removeClass('active-nav');
            showDropdown($dropdown);
            $dropdown.addClass('active-nav');
          } else {
            showDropdown($dropdown);
            $dropdown.addClass('active-nav');
          }
          $('body').addClass('no-scroll');
          // $overlay.show()
        }
      } else {
        $(this).addClass('is-active');
        showDropdown($dropdown);
      }
    }, 500, true));

    $anchors2.click((0, _utilities.debounce)(function (e) {
      e.preventDefault();
      var $dropdown = $(this).parents('.mega-nav-item').siblings('.mega-nav-child');
      $anchors2.removeClass('is-active');
      if (window.innerWidth >= navBreakpoint) {
        if ($dropdown.is(':visible')) {
          hideDropdown($dropdown, false);
          // $overlay.hide()
          scrollReset();
        } else {
          $(this).addClass('is-active');
          showDropdown($dropdown);
          // $overlay.show()
        }
      } else {
        $(this).addClass('is-active');
        showDropdown($dropdown);
      }
    }, 500, true));

    var masks = ['res-r', 'res-e', 'res-s', 'res-ul', 'res-t', 'res-t-line', 'res-ant', 'res-ant-line'];

    masks.forEach(function (mask) {
      var id = '#stroke-' + mask;
      var path = document.querySelector(id);
      if (path) {
        if (typeof path.getTotalLength === 'function') {
          var pathLength = path.getTotalLength();
          path.style.strokeDasharray = pathLength;
          path.style.strokeDashoffset = pathLength;
        } else {
          console.error('Element ' + id + ' is not an SVG path or getTotalLength is not a function');
        }
      } else {
        //console.error(`Element ${id} not found`);
      }
    });

    var $logoAnimation = $('#resultant-logo');
    var logoAnimated = false;

    if ($logoAnimation.length) {
      var restartAnimation = function restartAnimation() {
        $logoAnimation.removeClass('animated');
        setTimeout(function () {
          $logoAnimation.addClass('animated');
        }, 10);
      };

      $logoAnimation.addClass('animated');

      $(window).on('scroll', function () {
        if (!logoAnimated && $(window).scrollTop() > 100) {
          restartAnimation();
          logoAnimated = true;
        }
      });

      $(window).on('scroll', function () {
        if ($(window).scrollTop() === 0) {
          restartAnimation();
          logoAnimated = false;
        }
      });
    }
  });

  $('.m-header-nav-back-arrow').click(function () {
    if ($(this).parents('.m-header-nav-back').hasClass('back-to-parent')) {
      var $dropdown = $('.mega-nav-child:visible');
      hideDropdown($dropdown);
      $(this).parents('.m-header-nav-back').removeClass('back-to-parent');
    } else {
      hideAllTheThings(false);
    }
  });

  function fullNavSize() {
    if (window.innerWidth >= navBreakpoint && !$('.m-header-nav-nav').hasClass('scroll-nav')) {
      var windowW = window.innerWidth;
      var navPosition = $('.m-header-nav-nav').position();
      var navPositionLeft = navPosition.left + 0;
      $('.mega-nav').width(windowW);
      $('.mega-nav').css('left', '-' + navPositionLeft + 'px');
    } else if (window.innerWidth < navBreakpoint) {
      $('.mega-nav').width('100%');
      $('.mega-nav').css('left', 0);
    }
  }
  function showDropdown($dropdown) {
    $('.m-header-nav-nav').addClass('has-open-dropdown');
    // hideSearchForm()
    if (window.innerWidth >= navBreakpoint) {
      if (!$('.m-header-nav-nav').hasClass('scroll-nav')) {
        fullNavSize();
        $dropdown.velocity('finish').velocity('reverse').velocity('slideDown', {
          duration: 400,
          easing: 'easeInOut',
          complete: function complete() {}
        });
      } else {
        $dropdown.velocity('finish').velocity({
          opacity: [1, 0],
          translateX: [0, '100%']
        }, {
          duration: 200,
          easing: 'easeInOut',
          display: 'block',
          complete: function complete() {}
        });
        showBack($dropdown);
      }
    } else {
      $dropdown.velocity('finish').velocity({
        translateX: [0, '100%']
      }, {
        duration: 200,
        easing: 'easeInOut',
        display: 'block',
        complete: function complete() {}
      });
      showBack($dropdown);
    }
  }

  function showBack($dropdown) {
    var label = $dropdown.prev('.mega-menu-trigger').find('span:not(.mega-menu-label-arrow)').text();
    if ($dropdown.hasClass('mega-nav-child')) {
      label = $dropdown.parents('.parent').find('.mega-menu-trigger').find('span:not(.mega-menu-label-arrow)').text();
      $('.m-header-nav-back').addClass('back-to-parent');
      $('.m-header-nav-back-text').text(label);
    } else {
      $('.m-header-nav-back-text').text(label);
      $('.m-header-nav-back').velocity('finish').velocity({
        translateX: [0, '100%']
      }, {
        duration: 200,
        easing: 'easeInOut',
        display: 'block'
      });
    }
  }

  function hideBack($dropdown, immediate) {
    var $back = $('.m-header-nav-back:not(.scroll-back)');
    if (window.innerWidth >= navBreakpoint) {
      var $back = $('.m-header-nav-back.scroll-back');
    }
    if ($dropdown.hasClass('mega-nav-child')) {
      $dropdown.parents('.parent').find('.mega-menu-trigger.is-active').removeClass('is-active');
      var label = $dropdown.parents('.mega-menu-label').find('.mega-menu-trigger.is-active').find('span:not(.mega-menu-label-arrow)').text();
      $('.m-header-nav-back-text').text(label);
    } else {
      $('.m-header-nav-back').velocity('finish').velocity({
        translateX: ['100%', 0]
      }, {
        duration: immediate ? 0 : 200,
        easing: 'easeInOut',
        display: 'none'
      });
    }
  }

  function hideDropdown($dropdown, immediate) {
    jQuery(function ($) {
      if (!$dropdown.hasClass('mega-nav-child')) {
        $('.m-header-nav-nav').removeClass('has-open-dropdown');
      }
      if (window.innerWidth >= navBreakpoint) {
        if (!$('.m-header-nav-nav').hasClass('scroll-nav')) {
          $dropdown.velocity('finish').velocity('slideUp', {
            duration: 400,
            easing: 'easeInOut',
            complete: function complete() {}
          });
        } else {
          if ($dropdown.hasClass('mega-nav-child')) {
            $dropdown.velocity('finish').velocity('reverse').velocity({
              translateX: [0, '100%']
            }, {
              duration: immediate ? 0 : 200,
              easing: 'easeInOut',
              display: '',
              complete: function complete() {
                $dropdown.css('opacity', 1);
              }
            });
          } else {
            $dropdown.velocity('finish').velocity({
              translateX: ['100%', 0]
            }, {
              duration: immediate ? 0 : 200,
              easing: 'easeInOut',
              display: 'none',
              complete: function complete() {}
            });
          }
          hideBack($dropdown, false);
        }
      } else {
        $dropdown.velocity('finish').velocity({
          translateX: ['100%', 0]
        }, {
          duration: immediate ? 0 : 200,
          easing: 'easeInOut',
          display: 'none',
          complete: function complete() {}
        });
        hideBack($dropdown);
      }
    });
  }

  function hideAllTheThings(immediate) {
    var $dropdown = $('.mega-nav:visible');
    hideDropdown($dropdown, immediate);
    hideDropdown($('.mega-nav-child:visible'), immediate);
    // if( window.innerWidth >= navBreakpoint && $('.m-header-nav-nav').hasClass('scroll-only') ) {
    //   $('.mega-nav-child').velocity('finish').velocity('reverse').velocity({
    //       translateX: [0, '100%']
    //     }, {
    //       duration: 100,
    //       easing: 'easeInOut',
    //       display: 'block',
    //       complete: function() {

    //       }
    //     })
    // }
    $('.mega-nav.active-nav').removeClass('active-nav');
    $('.m-header-nav-nav').removeClass('has-open-dropdown');
    $('.m-header-nav').removeClass('open');
    $anchors.removeClass('is-active');
    $anchors2.removeClass('is-active');
  }

  // close mega nav when clicking off it
  $(document).on("click", function (event) {
    if ($("header nav").hasClass("open") && !$('header nav').hasClass('condensed')) {
      var $trigger_a = $("header");
      var $trigger_b = $(".mega-nav");
      if ($trigger_a !== event.target && !$trigger_a.has(event.target).length && $trigger_b !== event.target && !$trigger_b.has(event.target).length) {
        $('.m-header-nav').removeClass('open');
        $('.mega-nav').removeClass('active-nav');
        hideDropdown($('.mega-nav'), false);
        $('.mega-menu-trigger').removeClass('is-active');
        $('body').removeClass('no-scroll');
        scrollReset();
      }
    }
  });

  $('.m-header-search-toggle-wrapper').on('click', function (e) {
    e.preventDefault();
    $('.m-header').addClass('search-is-open');
    $('.m-header-nav-search').addClass('opened');
  });
  $('.m-header-nav-search .m-search-form-close').on('click', function () {
    $('.m-header').removeClass('search-is-open');
    $('.m-header-nav-search').removeClass('opened');
  });
});
function scrollOverride() {
  st = $(window).scrollTop();
  $('html, body').css({
    'overflow-y': 'hidden',
    'height': '100%'
  });
}
function scrollReset() {
  $('html, body').css({
    'overflow-y': 'visible',
    'height': 'auto'
  });
  if (st > 0) $(window).scrollTop(st);
}
exports.navBreakpoint = navBreakpoint;
exports.scrollOverride = scrollOverride;
exports.scrollReset = scrollReset;


$(window).on('resize', function () {
  if (window.innerWidth <= navBreakpoint - 1) {
    $('header').removeClass('condensed');
    $('nav').removeClass('open condensed');
    $('header button').removeClass('is-active');
    $('.m-header-nav-nav').removeClass('is-active has-open-dropdown scroll-nav');
  }
});

},{"../../../assets/src/js/utilities":2}],48:[function(require,module,exports){
'use strict';

var _headerNav = require('../header-nav/header-nav');

var _subnav = require('../subnav/subnav');

var ls = 0,
    $header = $('.m-header'),
    $nav = $('.m-header-nav-nav'),
    $eyebrow = $('.m-header-eyebrow'),
    $subnav = $('.js-subnav'),
    headerHeight,
    eyebrowHeight;

jQuery(function ($) {
  $(document).ready(function () {
    headerHeight = $header.outerHeight();
    if (window.innerWidth <= _headerNav.navBreakpoint - 1) {
      eyebrowHeight = 0;
    } else {
      eyebrowHeight = $eyebrow.outerHeight();
    }
    if ($(window).scrollTop() > 0) {
      scrollStuff();
    }
  });
  $(window).scroll(function () {
    (0, _subnav.toggleDockSubnav)();
    scrollStuff();
  });
  $(window).resize(function () {
    headerHeight = $header.outerHeight();
    if (window.innerWidth <= _headerNav.navBreakpoint - 1) {
      eyebrowHeight = 0;
    } else {
      eyebrowHeight = $eyebrow.outerHeight();
    }
  });
});

function scrollStuff() {

  jQuery(function ($) {
    var st = $(window).scrollTop();
    if ($('.m-header').hasClass('search-is-open')) {
      $('.m-header').removeClass('search-is-open');
      $('.m-header-nav-search').removeClass('opened');
    }

    if (st >= headerHeight && st > ls && $header.data('is-visible')) {
      // hide on scroll down
      if (window.innerWidth <= _headerNav.navBreakpoint - 1) {
        $header.velocity('finish').velocity({
          translateY: -headerHeight
        }, {
          duration: 400,
          easing: 'easeInOut',
          queue: false,
          progress: function progress() {
            return (0, _subnav.toggleDockSubnav)();
          }
        });
      } else {
        $header.velocity('finish').velocity({
          // translateY: -headerHeight
        }, {
          duration: 400,
          easing: 'easeInOut',
          queue: false,
          progress: function progress() {
            return (0, _subnav.toggleDockSubnav)();
          }
        });
      }
      $subnav.velocity('finish').velocity({
        translateY: 0
      }, {
        duration: 400,
        easing: 'easeInOut',
        queue: false
      });
      $eyebrow.data('is-visible', false);
      if (window.innerWidth >= _headerNav.navBreakpoint) {
        $header.data('is-visible', true).addClass('condensed');
        $nav.addClass('scroll-nav');
        $('.m-header-nav-thing > .mega-menu-label > .mega-menu-trigger').removeClass('top-trigger');
        $('.m-header-nav-nav').css('display', 'none');
      } else {
        $header.data('is-visible', false);
      }
    } else if (st < ls && !$header.data('is-visible')) {
      // show on scroll up
      if (window.innerWidth <= _headerNav.navBreakpoint - 1) {
        $header.velocity('finish').velocity({
          translateY: -eyebrowHeight
        }, {
          duration: 400,
          easing: 'easeInOut',
          queue: false,
          progress: function progress() {
            return (0, _subnav.toggleDockSubnav)();
          }
        });
      }
      $subnav.velocity('finish').velocity({
        translateY: headerHeight - eyebrowHeight
      }, {
        duration: 400,
        easing: 'easeInOut',
        queue: false
      });
      $eyebrow.data('is-visible', false);
      if (window.innerWidth >= _headerNav.navBreakpoint) {
        $header.data('is-visible', true).addClass('condensed');
        $nav.addClass('scroll-nav');
        $('.m-header-nav-thing > .mega-menu-label > .mega-menu-trigger').removeClass('top-trigger');
        $('.m-header-nav-nav').css('display', 'none');
      } else {
        $header.data('is-visible', true);
        $('.m-header-nav').addClass('inverse inverse-mobile');
      }
    } else if (st < ls && st !== 0 && window.innerWidth < _headerNav.navBreakpoint) {
      $('.m-header-nav').addClass('inverse inverse-mobile');
    } else if (st == 0) {
      $header.removeClass('condensed').removeClass('inverse');
      $('.m-header-nav').removeClass('inverse');
      if (!$('.m-header-nav-nav').hasClass('is-active')) {
        $('.m-header-nav').removeClass('inverse-mobile');
      }
      // $header.attr('data-is-visible', true)

      if (window.innerWidth >= _headerNav.navBreakpoint) {
        $nav.removeClass('scroll-nav');
        $('.m-header-nav-head').hide();
        $('.m-header-nav-nav:not(.has-open-dropdown)').css('transform', 'translateX(0)');
        $('.m-header-nav-thing > .mega-menu-label > .mega-menu-trigger').addClass('top-trigger');
      }
    }
    ls = st;
  });
}

},{"../header-nav/header-nav":47,"../subnav/subnav":49}],49:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleDockSubnav = undefined;

var _headerNav = require('../header-nav/header-nav');

var subnavWaypoint,
    $header = $('.m-header'),
    $eyebrow = $('.m-header-eyebrow'),
    $subnav = $('.js-subnav'),
    subnavIsDockable;

$(document).ready(function () {

  subnavIsDockable = $subnav.hasClass('is-dockable');

  addSubnavWrapper();

  $('.m-subnav-nav-list a:not(.is-active)').on('click', function () {
    $('.m-subnav-nav-list a.is-active').removeClass('is-active');
    $(this).addClass('is-active');
  });

  $(window).on("scroll", onScroll);

  function onScroll(event) {
    var scrollPos = $(window).scrollTop() + $(window).height();
    scrollPos = scrollPos - 400;
    $('.m-subnav-nav-list a.is-anchor').each(function () {
      var currLink = $(this);
      //console.log(currLink)
      var refElement = $(currLink.attr("href"));
      if (refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
        $('.m-subnav-nav-list a').removeClass("is-active");
        currLink.addClass("is-active");
      } else {
        currLink.removeClass("is-active");
      }
    });
  }

  $('.m-subnav-toggle').click(function () {
    if (window.innerWidth >= _headerNav.navBreakpoint) return;
    $(this).toggleClass('is-active');
    var $nav = $('.m-subnav-nav');
    if ($nav.is(':visible')) {
      $('.m-subnav-nav').velocity('slideUp', {
        duration: 250,
        easing: 'easeInOut'
      });
    } else {
      $('.m-subnav-nav').velocity('slideDown', {
        duration: 250,
        easing: 'easeInOut'
      });
    }
  });

  if (window.innerWidth <= _headerNav.navBreakpoint - 1) {
    var backlink = $.trim($('.m-subnav-back-title').text()),
        $active = $('.m-subnav-nav-list a.is-active').first(),
        active = $.trim($active.text());
    if ($active.length && active !== backlink) {
      $('.m-subnav-current').empty().append('<b> - ' + active + '</b>');
    }
  }

  $(window).resize(function () {
    return setWaypoint();
  });
});

$(window).on('load', function () {
  return setWaypoint();
});

function toggleDockSubnav() {
  if (!subnavIsDockable) return;

  if (typeof subnavWaypoint == 'undefined') setWaypoint();
  if (typeof subnavWaypoint == 'undefined') return;

  var st = $(window).scrollTop(),
      wp = subnavWaypoint;

  if ($eyebrow.data('is-visible') || window.innerWidth <= _headerNav.navBreakpoint - 1) {
    wp = subnavWaypoint - $header.outerHeight();
  } else if ($header.getTranslateY()) {
    wp = subnavWaypoint - $header.outerHeight() - $header.getTranslateY();
  }

  var hheight = $('.m-header.condensed').outerHeight();
  var subheight = $('.m-subnav.js-subnav').outerHeight();

  if (st > wp - subheight - 10) {
    $subnav.removeClass('is-static').addClass('is-fixed').css('top', hheight);
  } else {
    $subnav.removeClass('is-fixed').addClass('is-static').css('top', '');
  }
}

function addSubnavWrapper() {
  if (!subnavIsDockable) return;
  var $wrap = $('.m-subnav-wrapper');
  if ($wrap.length) return;
  $wrap = $('<div class="m-subnav-wrapper" />').height($subnav.outerHeight());
  $subnav.wrap($wrap);
}

function setWaypoint() {
  var $wrap = $('.m-subnav-wrapper');
  if ($wrap.length && subnavIsDockable) subnavWaypoint = $wrap.offset().top;
}

$.fn.extend({
  getTranslateY: function getTranslateY() {
    if (!$(this).length || $(this).css('transform') == 'none') return 0;
    return parseFloat($(this).css('transform').split(',')[5].replace(')', ''));
  }
});

exports.toggleDockSubnav = toggleDockSubnav;

},{"../header-nav/header-nav":47}]},{},[1]);
